var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/enums/ai.enum.ts
var AiModule = /* @__PURE__ */ (function(AiModule2) {
  AiModule2["CHAT"] = "chat";
  AiModule2["DOCS"] = "docs";
  AiModule2["SHEET_CONFIG"] = "sheet_config";
  AiModule2["SHEET_EXPLAIN"] = "sheet_explain";
  AiModule2["EMPLOYEE_APP"] = "employee_app";
  AiModule2["SCHEDULER"] = "scheduler";
  return AiModule2;
})({});
var AiMessageRole = /* @__PURE__ */ (function(AiMessageRole2) {
  AiMessageRole2["USER"] = "user";
  AiMessageRole2["ASSISTANT"] = "assistant";
  return AiMessageRole2;
})({});
var AiGuidanceAvailability = /* @__PURE__ */ (function(AiGuidanceAvailability2) {
  AiGuidanceAvailability2["AVAILABLE"] = "available";
  AiGuidanceAvailability2["PERMISSION_REQUIRED"] = "permission_required";
  AiGuidanceAvailability2["NEEDS_REVIEW"] = "needs_review";
  AiGuidanceAvailability2["UNSUPPORTED"] = "unsupported";
  return AiGuidanceAvailability2;
})({});
var AiGuidanceAnswerStatus = /* @__PURE__ */ (function(AiGuidanceAnswerStatus2) {
  AiGuidanceAnswerStatus2["ANSWERED"] = "answered";
  AiGuidanceAnswerStatus2["INSUFFICIENT_EVIDENCE"] = "insufficient_evidence";
  return AiGuidanceAnswerStatus2;
})({});
var AiGuidanceQuestionKind = /* @__PURE__ */ (function(AiGuidanceQuestionKind2) {
  AiGuidanceQuestionKind2["USAGE"] = "usage";
  AiGuidanceQuestionKind2["PRE_SUBMISSION"] = "pre_submission";
  AiGuidanceQuestionKind2["OUTCOME_INFERENCE"] = "outcome_inference";
  return AiGuidanceQuestionKind2;
})({});
var AiGuideSearchStatus = /* @__PURE__ */ (function(AiGuideSearchStatus2) {
  AiGuideSearchStatus2["FOUND"] = "found";
  AiGuideSearchStatus2["NO_EVIDENCE"] = "no_evidence";
  AiGuideSearchStatus2["UNAVAILABLE"] = "unavailable";
  return AiGuideSearchStatus2;
})({});
var AiGuideProvider = /* @__PURE__ */ (function(AiGuideProvider2) {
  AiGuideProvider2["VECTOR"] = "vector";
  AiGuideProvider2["KEYWORD"] = "keyword";
  return AiGuideProvider2;
})({});
var AiKeySource = /* @__PURE__ */ (function(AiKeySource2) {
  AiKeySource2["PLATFORM"] = "platform";
  AiKeySource2["BYOK"] = "byok";
  return AiKeySource2;
})({});
var AiFeedbackRating = /* @__PURE__ */ (function(AiFeedbackRating2) {
  AiFeedbackRating2["UP"] = "up";
  AiFeedbackRating2["DOWN"] = "down";
  return AiFeedbackRating2;
})({});
var AiMessageStatus = /* @__PURE__ */ (function(AiMessageStatus2) {
  AiMessageStatus2["OK"] = "ok";
  AiMessageStatus2["ERROR"] = "error";
  return AiMessageStatus2;
})({});
var AiErrorCode = /* @__PURE__ */ (function(AiErrorCode2) {
  AiErrorCode2["RATE_LIMITED"] = "rate_limited";
  AiErrorCode2["OVERLOADED"] = "overloaded";
  AiErrorCode2["AUTH"] = "auth";
  AiErrorCode2["INVALID_REQUEST"] = "invalid_request";
  AiErrorCode2["PROVIDER_ERROR"] = "provider_error";
  AiErrorCode2["TIMEOUT"] = "timeout";
  AiErrorCode2["NETWORK"] = "network";
  AiErrorCode2["POSTPROCESS"] = "postprocess";
  AiErrorCode2["UNKNOWN"] = "unknown";
  return AiErrorCode2;
})({});
var AiChatPurpose = /* @__PURE__ */ (function(AiChatPurpose2) {
  AiChatPurpose2["CHAT"] = "chat";
  AiChatPurpose2["GUIDE"] = "guide";
  return AiChatPurpose2;
})({});

// src/enums/ai-docs.enum.ts
var AiDocumentOriginKind = /* @__PURE__ */ (function(AiDocumentOriginKind2) {
  AiDocumentOriginKind2["Text"] = "text";
  AiDocumentOriginKind2["Json"] = "json";
  return AiDocumentOriginKind2;
})({});
var AiDocumentSpanKind = /* @__PURE__ */ (function(AiDocumentSpanKind2) {
  AiDocumentSpanKind2["Content"] = "content";
  AiDocumentSpanKind2["Context"] = "context";
  AiDocumentSpanKind2["Syntax"] = "syntax";
  return AiDocumentSpanKind2;
})({});

// src/enums/annual-leave-promotion.enum.ts
var AnnualLeavePromotionBusinessStatus = /* @__PURE__ */ (function(AnnualLeavePromotionBusinessStatus2) {
  AnnualLeavePromotionBusinessStatus2["NOT_NOTIFIED"] = "not_notified";
  AnnualLeavePromotionBusinessStatus2["AWAITING_SIGNATURE"] = "awaiting_signature";
  AnnualLeavePromotionBusinessStatus2["APPLIED"] = "applied";
  AnnualLeavePromotionBusinessStatus2["EXPIRED_CANCELLED"] = "expired_cancelled";
  AnnualLeavePromotionBusinessStatus2["SECOND_DESIGNATED"] = "second_designated";
  return AnnualLeavePromotionBusinessStatus2;
})({});
var AnnualLeavePromotionProcessingStatus = /* @__PURE__ */ (function(AnnualLeavePromotionProcessingStatus2) {
  AnnualLeavePromotionProcessingStatus2["IDLE"] = "idle";
  AnnualLeavePromotionProcessingStatus2["PROCESSING"] = "processing";
  AnnualLeavePromotionProcessingStatus2["RETRYABLE_FAILURE"] = "retryable_failure";
  AnnualLeavePromotionProcessingStatus2["REVIEW_REQUIRED"] = "review_required";
  AnnualLeavePromotionProcessingStatus2["COMPLETED"] = "completed";
  return AnnualLeavePromotionProcessingStatus2;
})({});
var AnnualLeavePromotionAttemptStatus = /* @__PURE__ */ (function(AnnualLeavePromotionAttemptStatus2) {
  AnnualLeavePromotionAttemptStatus2["PREPARING"] = "preparing";
  AnnualLeavePromotionAttemptStatus2["PENDING_PUBLICATION"] = "pending_publication";
  AnnualLeavePromotionAttemptStatus2["AWAITING_SIGNATURE"] = "awaiting_signature";
  AnnualLeavePromotionAttemptStatus2["COMPLETED"] = "completed";
  AnnualLeavePromotionAttemptStatus2["EXPIRED"] = "expired";
  AnnualLeavePromotionAttemptStatus2["CANCELLED"] = "cancelled";
  AnnualLeavePromotionAttemptStatus2["FAILED"] = "failed";
  AnnualLeavePromotionAttemptStatus2["REVIEW_REQUIRED"] = "review_required";
  return AnnualLeavePromotionAttemptStatus2;
})({});
var AnnualLeavePromotionMessagePurpose = /* @__PURE__ */ (function(AnnualLeavePromotionMessagePurpose2) {
  AnnualLeavePromotionMessagePurpose2["FIRST"] = "annual_leave_promotion_first";
  AnnualLeavePromotionMessagePurpose2["REMINDER"] = "annual_leave_promotion_reminder";
  AnnualLeavePromotionMessagePurpose2["SECOND"] = "annual_leave_promotion_second";
  return AnnualLeavePromotionMessagePurpose2;
})({});
var AnnualLeavePromotionBatchStatus = /* @__PURE__ */ (function(AnnualLeavePromotionBatchStatus2) {
  AnnualLeavePromotionBatchStatus2["MATERIALIZING"] = "materializing";
  AnnualLeavePromotionBatchStatus2["QUEUED"] = "queued";
  AnnualLeavePromotionBatchStatus2["RUNNING"] = "running";
  AnnualLeavePromotionBatchStatus2["CANCEL_REQUESTED"] = "cancel_requested";
  AnnualLeavePromotionBatchStatus2["COMPLETED"] = "completed";
  AnnualLeavePromotionBatchStatus2["COMPLETED_WITH_ISSUES"] = "completed_with_issues";
  AnnualLeavePromotionBatchStatus2["CANCELLED"] = "cancelled";
  AnnualLeavePromotionBatchStatus2["FAILED"] = "failed";
  return AnnualLeavePromotionBatchStatus2;
})({});
var AnnualLeavePromotionBatchItemStatus = /* @__PURE__ */ (function(AnnualLeavePromotionBatchItemStatus2) {
  AnnualLeavePromotionBatchItemStatus2["PENDING"] = "pending";
  AnnualLeavePromotionBatchItemStatus2["CLAIMED"] = "claimed";
  AnnualLeavePromotionBatchItemStatus2["SUCCEEDED"] = "succeeded";
  AnnualLeavePromotionBatchItemStatus2["FAILED"] = "failed";
  AnnualLeavePromotionBatchItemStatus2["CANCELLED"] = "cancelled";
  AnnualLeavePromotionBatchItemStatus2["SKIPPED"] = "skipped";
  return AnnualLeavePromotionBatchItemStatus2;
})({});
var AnnualLeavePromotionSelectionMode = /* @__PURE__ */ (function(AnnualLeavePromotionSelectionMode2) {
  AnnualLeavePromotionSelectionMode2["EXPLICIT"] = "explicit";
  AnnualLeavePromotionSelectionMode2["ALL_ELIGIBLE_IN_SCOPE"] = "all_eligible_in_scope";
  return AnnualLeavePromotionSelectionMode2;
})({});
var WorkflowMessagePublicationState = /* @__PURE__ */ (function(WorkflowMessagePublicationState2) {
  WorkflowMessagePublicationState2["PENDING_PUBLICATION"] = "pending_publication";
  WorkflowMessagePublicationState2["PUBLISHED"] = "published";
  return WorkflowMessagePublicationState2;
})({});

// src/enums/app-onboarding.enum.ts
var AppOnboardingStage = /* @__PURE__ */ (function(AppOnboardingStage2) {
  AppOnboardingStage2["NOT_SENT"] = "not_sent";
  AppOnboardingStage2["SENT"] = "sent";
  AppOnboardingStage2["INSTALLED"] = "installed";
  AppOnboardingStage2["LOGGED_IN"] = "logged_in";
  AppOnboardingStage2["PASSWORD_CHANGED"] = "password_changed";
  AppOnboardingStage2["TUTORIAL_DONE"] = "tutorial_done";
  return AppOnboardingStage2;
})({});
var AppGuideChannel = /* @__PURE__ */ (function(AppGuideChannel2) {
  AppGuideChannel2["SMS"] = "sms";
  AppGuideChannel2["EMAIL"] = "email";
  return AppGuideChannel2;
})({});
var AppGuideSendStatus = /* @__PURE__ */ (function(AppGuideSendStatus2) {
  AppGuideSendStatus2["SENT"] = "sent";
  AppGuideSendStatus2["FAILED"] = "failed";
  AppGuideSendStatus2["SKIPPED"] = "skipped";
  return AppGuideSendStatus2;
})({});
var AppGuideTargetMode = /* @__PURE__ */ (function(AppGuideTargetMode2) {
  AppGuideTargetMode2["EXPLICIT"] = "explicit";
  AppGuideTargetMode2["ALL"] = "all";
  AppGuideTargetMode2["UNSENT"] = "unsent";
  AppGuideTargetMode2["INCOMPLETE"] = "incomplete";
  AppGuideTargetMode2["FAILED"] = "failed";
  return AppGuideTargetMode2;
})({});
var AppTutorialStep = /* @__PURE__ */ (function(AppTutorialStep2) {
  AppTutorialStep2["NOTIFICATIONS"] = "notifications";
  AppTutorialStep2["SHIFTS"] = "shifts";
  AppTutorialStep2["REQUESTS"] = "requests";
  AppTutorialStep2["PAYSLIP"] = "payslip";
  AppTutorialStep2["REPORT"] = "report";
  AppTutorialStep2["AI_ASSISTANT"] = "ai_assistant";
  return AppTutorialStep2;
})({});
var AppOnboardingChecklistStep = /* @__PURE__ */ (function(AppOnboardingChecklistStep2) {
  AppOnboardingChecklistStep2["CONTACTS"] = "contacts";
  AppOnboardingChecklistStep2["PASSWORD_POLICY"] = "password_policy";
  AppOnboardingChecklistStep2["SEND_GUIDE"] = "send_guide";
  AppOnboardingChecklistStep2["INSTALL_STATUS"] = "install_status";
  AppOnboardingChecklistStep2["RESEND"] = "resend";
  AppOnboardingChecklistStep2["NOTICE"] = "notice";
  AppOnboardingChecklistStep2["COMPLETE"] = "complete";
  return AppOnboardingChecklistStep2;
})({});

// src/enums/approval.enum.ts
var ApprovalRequestType = /* @__PURE__ */ (function(ApprovalRequestType2) {
  ApprovalRequestType2["LEAVE"] = "leave";
  ApprovalRequestType2["OVERTIME"] = "overtime";
  ApprovalRequestType2["OFFSITE_WORK"] = "offsite_work";
  ApprovalRequestType2["INCENTIVE"] = "incentive";
  ApprovalRequestType2["TREATMENT_SESSION"] = "treatment_session";
  ApprovalRequestType2["ATTENDANCE_CORRECTION"] = "attendance_correction";
  return ApprovalRequestType2;
})({});
var ApprovalStepStatus = /* @__PURE__ */ (function(ApprovalStepStatus2) {
  ApprovalStepStatus2["WAITING"] = "waiting";
  ApprovalStepStatus2["PENDING"] = "pending";
  ApprovalStepStatus2["APPROVED"] = "approved";
  ApprovalStepStatus2["REJECTED"] = "rejected";
  ApprovalStepStatus2["SKIPPED"] = "skipped";
  return ApprovalStepStatus2;
})({});
var ApprovalChangeEvent = /* @__PURE__ */ (function(ApprovalChangeEvent2) {
  ApprovalChangeEvent2["MY_LINE_SAVED"] = "my_line_saved";
  ApprovalChangeEvent2["MY_LINE_DELETED"] = "my_line_deleted";
  ApprovalChangeEvent2["TEAM_TEMPLATE_SAVED"] = "team_template_saved";
  ApprovalChangeEvent2["TEAM_TEMPLATE_CLEARED"] = "team_template_cleared";
  ApprovalChangeEvent2["ORG_TEMPLATE_SAVED"] = "org_template_saved";
  ApprovalChangeEvent2["ORG_TEMPLATE_CLEARED"] = "org_template_cleared";
  ApprovalChangeEvent2["ORG_POLICY_CHANGED"] = "org_policy_changed";
  ApprovalChangeEvent2["TEAM_POLICY_CHANGED"] = "team_policy_changed";
  ApprovalChangeEvent2["APPROVER_REPLACED"] = "approver_replaced";
  ApprovalChangeEvent2["VIEWER_ADDED"] = "viewer_added";
  ApprovalChangeEvent2["VIEWER_REMOVED"] = "viewer_removed";
  ApprovalChangeEvent2["CONFIDENTIAL_SET"] = "confidential_set";
  ApprovalChangeEvent2["CONFIDENTIAL_CLEARED"] = "confidential_cleared";
  return ApprovalChangeEvent2;
})({});
var ApprovalChangeTarget = /* @__PURE__ */ (function(ApprovalChangeTarget2) {
  ApprovalChangeTarget2["LINE"] = "line";
  ApprovalChangeTarget2["TEAM"] = "team";
  ApprovalChangeTarget2["ORGANIZATION"] = "organization";
  ApprovalChangeTarget2["STEP"] = "step";
  ApprovalChangeTarget2["REQUEST"] = "request";
  return ApprovalChangeTarget2;
})({});

// src/enums/attendance.enum.ts
var AttendanceMethod = /* @__PURE__ */ (function(AttendanceMethod2) {
  AttendanceMethod2["SECOM"] = "secom";
  AttendanceMethod2["APP"] = "app";
  AttendanceMethod2["MANUAL"] = "manual";
  return AttendanceMethod2;
})({});
var AttendanceStatus = /* @__PURE__ */ (function(AttendanceStatus2) {
  AttendanceStatus2["SCHEDULED"] = "scheduled";
  AttendanceStatus2["CHECKED_IN"] = "checked_in";
  AttendanceStatus2["CHECKED_OUT"] = "checked_out";
  AttendanceStatus2["ABSENT"] = "absent";
  AttendanceStatus2["LATE"] = "late";
  AttendanceStatus2["EARLY_LEAVE"] = "early_leave";
  AttendanceStatus2["HOLIDAY"] = "holiday";
  AttendanceStatus2["LEAVE"] = "leave";
  AttendanceStatus2["SICK_LEAVE"] = "sick_leave";
  return AttendanceStatus2;
})({});
var AttendanceType = /* @__PURE__ */ (function(AttendanceType2) {
  AttendanceType2["REGULAR"] = "regular";
  AttendanceType2["OVERTIME"] = "overtime";
  AttendanceType2["WEEKEND"] = "weekend";
  AttendanceType2["HOLIDAY"] = "holiday";
  AttendanceType2["NIGHT"] = "night";
  AttendanceType2["EMERGENCY"] = "emergency";
  return AttendanceType2;
})({});
var ShiftType = /* @__PURE__ */ (function(ShiftType2) {
  ShiftType2["DAY"] = "day";
  ShiftType2["NIGHT"] = "night";
  ShiftType2["EVENING"] = "evening";
  ShiftType2["WEEKEND_DAY"] = "weekend_day";
  ShiftType2["WEEKEND_NIGHT"] = "weekend_night";
  ShiftType2["HOLIDAY"] = "holiday";
  ShiftType2["FLEXIBLE"] = "flexible";
  return ShiftType2;
})({});
var ShiftClassification = /* @__PURE__ */ (function(ShiftClassification2) {
  ShiftClassification2["REGULAR"] = "regular";
  ShiftClassification2["OVERTIME"] = "overtime";
  return ShiftClassification2;
})({});
var ShiftStatus = /* @__PURE__ */ (function(ShiftStatus2) {
  ShiftStatus2["ACTIVE"] = "active";
  ShiftStatus2["INACTIVE"] = "inactive";
  ShiftStatus2["DRAFT"] = "draft";
  ShiftStatus2["ARCHIVED"] = "archived";
  return ShiftStatus2;
})({});
var AttendanceActionType = /* @__PURE__ */ (function(AttendanceActionType2) {
  AttendanceActionType2["CHECK_IN"] = "check_in";
  AttendanceActionType2["CHECK_OUT"] = "check_out";
  AttendanceActionType2["BREAK_START"] = "break_start";
  AttendanceActionType2["BREAK_END"] = "break_end";
  return AttendanceActionType2;
})({});
var AttendanceDisplayStatus = /* @__PURE__ */ (function(AttendanceDisplayStatus2) {
  AttendanceDisplayStatus2["PRESENT"] = "present";
  AttendanceDisplayStatus2["ABSENT"] = "absent";
  AttendanceDisplayStatus2["LATE"] = "late";
  AttendanceDisplayStatus2["EARLY_LEAVE"] = "early_leave";
  AttendanceDisplayStatus2["ON_LEAVE"] = "on_leave";
  AttendanceDisplayStatus2["HOLIDAY"] = "holiday";
  AttendanceDisplayStatus2["WEEKEND"] = "weekend";
  return AttendanceDisplayStatus2;
})({});
var DayOfWeek = /* @__PURE__ */ (function(DayOfWeek2) {
  DayOfWeek2["MONDAY"] = "monday";
  DayOfWeek2["TUESDAY"] = "tuesday";
  DayOfWeek2["WEDNESDAY"] = "wednesday";
  DayOfWeek2["THURSDAY"] = "thursday";
  DayOfWeek2["FRIDAY"] = "friday";
  DayOfWeek2["SATURDAY"] = "saturday";
  DayOfWeek2["SUNDAY"] = "sunday";
  return DayOfWeek2;
})({});
var RecurrencePattern = /* @__PURE__ */ (function(RecurrencePattern2) {
  RecurrencePattern2["DAILY"] = "daily";
  RecurrencePattern2["WEEKLY"] = "weekly";
  RecurrencePattern2["BIWEEKLY"] = "biweekly";
  RecurrencePattern2["MONTHLY"] = "monthly";
  RecurrencePattern2["CUSTOM"] = "custom";
  RecurrencePattern2["NONE"] = "none";
  return RecurrencePattern2;
})({});
var ShiftAssignmentStatus = /* @__PURE__ */ (function(ShiftAssignmentStatus2) {
  ShiftAssignmentStatus2["SCHEDULED"] = "scheduled";
  ShiftAssignmentStatus2["CONFIRMED"] = "confirmed";
  ShiftAssignmentStatus2["IN_PROGRESS"] = "in_progress";
  ShiftAssignmentStatus2["COMPLETED"] = "completed";
  ShiftAssignmentStatus2["CANCELLED"] = "cancelled";
  ShiftAssignmentStatus2["NO_SHOW"] = "no_show";
  return ShiftAssignmentStatus2;
})({});
var ShiftSwapStatus = /* @__PURE__ */ (function(ShiftSwapStatus2) {
  ShiftSwapStatus2["PENDING"] = "pending";
  ShiftSwapStatus2["APPROVED"] = "approved";
  ShiftSwapStatus2["REJECTED"] = "rejected";
  ShiftSwapStatus2["CANCELLED"] = "cancelled";
  return ShiftSwapStatus2;
})({});
var RotationPeriod = /* @__PURE__ */ (function(RotationPeriod2) {
  RotationPeriod2["WEEKLY"] = "weekly";
  RotationPeriod2["BIWEEKLY"] = "biweekly";
  RotationPeriod2["MONTHLY"] = "monthly";
  RotationPeriod2["CUSTOM"] = "custom";
  return RotationPeriod2;
})({});
var ShiftSortBy = /* @__PURE__ */ (function(ShiftSortBy2) {
  ShiftSortBy2["NAME"] = "name";
  ShiftSortBy2["CODE"] = "code";
  ShiftSortBy2["START_TIME"] = "startTime";
  ShiftSortBy2["TYPE"] = "type";
  ShiftSortBy2["CREATED_AT"] = "createdAt";
  return ShiftSortBy2;
})({});
var ShiftResolutionSource = /* @__PURE__ */ (function(ShiftResolutionSource2) {
  ShiftResolutionSource2["SCHEDULE"] = "schedule";
  ShiftResolutionSource2["EMPLOYEE_SHIFT"] = "employee_shift";
  ShiftResolutionSource2["GROUP_SHIFT"] = "group_shift";
  ShiftResolutionSource2["WORK_PATTERN_DEFAULT"] = "work_pattern_default";
  ShiftResolutionSource2["JOB_DUTY_DEFAULT"] = "job_duty_default";
  ShiftResolutionSource2["TEAM_REPRESENTATIVE"] = "team_representative";
  ShiftResolutionSource2["ORG_DEFAULT_SHIFT"] = "org_default_shift";
  ShiftResolutionSource2["ORG_DEFAULT_TIME"] = "org_default_time";
  ShiftResolutionSource2["OFF_DAY"] = "off_day";
  ShiftResolutionSource2["INFERRED"] = "inferred";
  ShiftResolutionSource2["PREVIOUS"] = "previous";
  return ShiftResolutionSource2;
})({});
var ShiftAssignmentSource = /* @__PURE__ */ (function(ShiftAssignmentSource2) {
  ShiftAssignmentSource2["MANUAL"] = "manual";
  ShiftAssignmentSource2["WORK_PATTERN_DEFAULT"] = "work_pattern_default";
  ShiftAssignmentSource2["JOB_DUTY_DEFAULT"] = "job_duty_default";
  ShiftAssignmentSource2["TEAM_REPRESENTATIVE"] = "team_representative";
  ShiftAssignmentSource2["BULK_ASSIGN"] = "bulk_assign";
  ShiftAssignmentSource2["BULK_UPLOAD"] = "bulk_upload";
  ShiftAssignmentSource2["SHEET"] = "sheet";
  ShiftAssignmentSource2["SELF"] = "self";
  ShiftAssignmentSource2["CARRIED"] = "carried";
  ShiftAssignmentSource2["MIGRATION"] = "migration";
  return ShiftAssignmentSource2;
})({});

// src/enums/attendance-correction.enum.ts
var AttendanceCorrectionKind = /* @__PURE__ */ (function(AttendanceCorrectionKind2) {
  AttendanceCorrectionKind2["FIX_TIME"] = "fix_time";
  AttendanceCorrectionKind2["ADD_MISSING"] = "add_missing";
  return AttendanceCorrectionKind2;
})({});
var AttendanceCorrectionStatus = /* @__PURE__ */ (function(AttendanceCorrectionStatus2) {
  AttendanceCorrectionStatus2["PENDING"] = "pending";
  AttendanceCorrectionStatus2["APPROVED"] = "approved";
  AttendanceCorrectionStatus2["REJECTED"] = "rejected";
  AttendanceCorrectionStatus2["CANCELLED"] = "cancelled";
  return AttendanceCorrectionStatus2;
})({});

// src/enums/attendance-rate.enum.ts
var AttendanceRateRoundingMode = /* @__PURE__ */ (function(AttendanceRateRoundingMode2) {
  AttendanceRateRoundingMode2["CEIL"] = "ceil";
  AttendanceRateRoundingMode2["ROUND"] = "round";
  AttendanceRateRoundingMode2["FLOOR"] = "floor";
  return AttendanceRateRoundingMode2;
})({});

// src/enums/auth.enum.ts
var TokenType = /* @__PURE__ */ (function(TokenType2) {
  TokenType2["ACCESS"] = "ACCESS";
  TokenType2["REFRESH"] = "REFRESH";
  TokenType2["PASSWORD_RESET"] = "PASSWORD_RESET";
  TokenType2["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
  return TokenType2;
})({});
var TokenStatus = /* @__PURE__ */ (function(TokenStatus2) {
  TokenStatus2["ACTIVE"] = "ACTIVE";
  TokenStatus2["REVOKED"] = "REVOKED";
  TokenStatus2["EXPIRED"] = "EXPIRED";
  TokenStatus2["USED"] = "USED";
  return TokenStatus2;
})({});
var AuthMethod = /* @__PURE__ */ (function(AuthMethod2) {
  AuthMethod2["EMAIL"] = "email";
  AuthMethod2["PHONE"] = "phone";
  AuthMethod2["PHONE_OTP"] = "phone_otp";
  AuthMethod2["BIOMETRIC"] = "biometric";
  return AuthMethod2;
})({});
var AccountStatus = /* @__PURE__ */ (function(AccountStatus2) {
  AccountStatus2["PENDING"] = "PENDING";
  AccountStatus2["ACTIVE"] = "ACTIVE";
  AccountStatus2["SUSPENDED"] = "SUSPENDED";
  return AccountStatus2;
})({});
var PlatformRole = /* @__PURE__ */ (function(PlatformRole2) {
  PlatformRole2["SUPPORT"] = "SUPPORT";
  PlatformRole2["OPERATOR"] = "OPERATOR";
  return PlatformRole2;
})({});
var GrantKind = /* @__PURE__ */ (function(GrantKind2) {
  GrantKind2["SUPPORT"] = "SUPPORT";
  GrantKind2["CUSTOM"] = "CUSTOM";
  return GrantKind2;
})({});
var GrantOrigin = /* @__PURE__ */ (function(GrantOrigin2) {
  GrantOrigin2["PLATFORM"] = "PLATFORM";
  GrantOrigin2["ORG_DEBUG"] = "ORG_DEBUG";
  return GrantOrigin2;
})({});
var AuditActorKind = /* @__PURE__ */ (function(AuditActorKind2) {
  AuditActorKind2["SYSTEM_ADMIN"] = "SYSTEM_ADMIN";
  AuditActorKind2["MEMBER"] = "MEMBER";
  AuditActorKind2["OWNER"] = "OWNER";
  AuditActorKind2["GRANT"] = "GRANT";
  AuditActorKind2["IMPERSONATION"] = "IMPERSONATION";
  AuditActorKind2["OPERATOR"] = "OPERATOR";
  return AuditActorKind2;
})({});
var DeviceCredentialKind = /* @__PURE__ */ (function(DeviceCredentialKind2) {
  DeviceCredentialKind2["PASSKEY"] = "passkey";
  DeviceCredentialKind2["DEVICE_KEY"] = "device_key";
  return DeviceCredentialKind2;
})({});

// src/enums/chat-encryption.enum.ts
var ChatDeviceLinkStatus = /* @__PURE__ */ (function(ChatDeviceLinkStatus2) {
  ChatDeviceLinkStatus2["PENDING"] = "pending";
  ChatDeviceLinkStatus2["APPROVED"] = "approved";
  ChatDeviceLinkStatus2["CLAIMED"] = "claimed";
  ChatDeviceLinkStatus2["EXPIRED"] = "expired";
  return ChatDeviceLinkStatus2;
})({});
var ConversationKeyEpochReason = /* @__PURE__ */ (function(ConversationKeyEpochReason2) {
  ConversationKeyEpochReason2["CREATE"] = "create";
  ConversationKeyEpochReason2["MEMBER_ADDED"] = "member_added";
  ConversationKeyEpochReason2["MEMBER_REMOVED"] = "member_removed";
  ConversationKeyEpochReason2["ROTATE"] = "rotate";
  ConversationKeyEpochReason2["MIGRATION"] = "migration";
  ConversationKeyEpochReason2["RECOVERY_KEY_ROTATE"] = "recovery_key_rotate";
  return ConversationKeyEpochReason2;
})({});
var MessengerPushFormat = /* @__PURE__ */ (function(MessengerPushFormat2) {
  MessengerPushFormat2["NAME_BODY"] = "name_body";
  MessengerPushFormat2["NAME_ONLY"] = "name_only";
  MessengerPushFormat2["GENERIC"] = "generic";
  return MessengerPushFormat2;
})({});

// src/enums/chat-recovery.enum.ts
var ChatRecoveryReasonKind = /* @__PURE__ */ (function(ChatRecoveryReasonKind2) {
  ChatRecoveryReasonKind2["LEGAL_REQUEST"] = "legal_request";
  ChatRecoveryReasonKind2["AUDIT_CHECK"] = "audit_check";
  return ChatRecoveryReasonKind2;
})({});
var ChatRecoveryStatus = /* @__PURE__ */ (function(ChatRecoveryStatus2) {
  ChatRecoveryStatus2["REQUESTED"] = "requested";
  ChatRecoveryStatus2["HOSPITAL_APPROVED"] = "hospital_approved";
  ChatRecoveryStatus2["OPERATOR_APPROVED"] = "operator_approved";
  ChatRecoveryStatus2["RELEASED"] = "released";
  ChatRecoveryStatus2["COMPLETED"] = "completed";
  ChatRecoveryStatus2["REJECTED"] = "rejected";
  ChatRecoveryStatus2["EXPIRED"] = "expired";
  return ChatRecoveryStatus2;
})({});
var ChatRecoveryAuditStep = /* @__PURE__ */ (function(ChatRecoveryAuditStep2) {
  ChatRecoveryAuditStep2["CREATED"] = "created";
  ChatRecoveryAuditStep2["HOSPITAL_APPROVED"] = "hospital_approved";
  ChatRecoveryAuditStep2["HOSPITAL_REJECTED"] = "hospital_rejected";
  ChatRecoveryAuditStep2["DOCUMENT_VIEWED"] = "document_viewed";
  ChatRecoveryAuditStep2["OPERATOR_APPROVED"] = "operator_approved";
  ChatRecoveryAuditStep2["ENVELOPES_READ"] = "envelopes_read";
  ChatRecoveryAuditStep2["RELEASED"] = "released";
  ChatRecoveryAuditStep2["HANDOFF_CLAIMED"] = "handoff_claimed";
  ChatRecoveryAuditStep2["COMPLETED"] = "completed";
  ChatRecoveryAuditStep2["EXPIRED"] = "expired";
  return ChatRecoveryAuditStep2;
})({});
var ChatRecoveryActorKind = /* @__PURE__ */ (function(ChatRecoveryActorKind2) {
  ChatRecoveryActorKind2["HOSPITAL"] = "hospital";
  ChatRecoveryActorKind2["OPERATOR"] = "operator";
  ChatRecoveryActorKind2["SYSTEM"] = "system";
  return ChatRecoveryActorKind2;
})({});

// src/enums/common.enum.ts
var SortOrder = /* @__PURE__ */ (function(SortOrder2) {
  SortOrder2["ASC"] = "asc";
  SortOrder2["DESC"] = "desc";
  return SortOrder2;
})({});
var VerificationType = /* @__PURE__ */ (function(VerificationType2) {
  VerificationType2["EMAIL"] = "email";
  VerificationType2["PHONE"] = "phone";
  return VerificationType2;
})({});
var ResetMethod = /* @__PURE__ */ (function(ResetMethod2) {
  ResetMethod2["EMAIL"] = "email";
  ResetMethod2["SMS"] = "sms";
  return ResetMethod2;
})({});
var TwoFactorMethod = /* @__PURE__ */ (function(TwoFactorMethod2) {
  TwoFactorMethod2["TOTP"] = "totp";
  TwoFactorMethod2["SMS"] = "sms";
  return TwoFactorMethod2;
})({});

// src/enums/communication.enum.ts
var ConversationType = /* @__PURE__ */ (function(ConversationType2) {
  ConversationType2["DIRECT"] = "direct";
  ConversationType2["GROUP"] = "group";
  ConversationType2["CHANNEL"] = "channel";
  ConversationType2["WORKFLOW"] = "workflow";
  ConversationType2["SELF"] = "self";
  ConversationType2["TEAM"] = "department";
  return ConversationType2;
})({});
var ConversationMemberRole = /* @__PURE__ */ (function(ConversationMemberRole2) {
  ConversationMemberRole2["OWNER"] = "owner";
  ConversationMemberRole2["MEMBER"] = "member";
  return ConversationMemberRole2;
})({});
var ConversationMembershipStatus = /* @__PURE__ */ (function(ConversationMembershipStatus2) {
  ConversationMembershipStatus2["ACTIVE"] = "active";
  ConversationMembershipStatus2["PENDING"] = "pending";
  ConversationMembershipStatus2["REJECTED"] = "rejected";
  return ConversationMembershipStatus2;
})({});
var MessageType = /* @__PURE__ */ (function(MessageType2) {
  MessageType2["TEXT"] = "text";
  MessageType2["SYSTEM"] = "system";
  MessageType2["FILE"] = "file";
  MessageType2["IMAGE"] = "image";
  return MessageType2;
})({});
var DocumentStatus = /* @__PURE__ */ (function(DocumentStatus2) {
  DocumentStatus2["PROCESSING"] = "processing";
  DocumentStatus2["APPROVED"] = "approved";
  DocumentStatus2["REJECTED"] = "rejected";
  DocumentStatus2["CANCELLED"] = "cancelled";
  DocumentStatus2["REQUIRES_REVIEW"] = "requires_review";
  return DocumentStatus2;
})({});
var DocumentCategory = /* @__PURE__ */ (function(DocumentCategory2) {
  DocumentCategory2["MEDICAL"] = "medical";
  DocumentCategory2["CERTIFICATION"] = "certification";
  DocumentCategory2["OVERTIME"] = "overtime";
  DocumentCategory2["CONTRACT"] = "contract";
  DocumentCategory2["OTHER"] = "other";
  return DocumentCategory2;
})({});
var DevicePlatform = /* @__PURE__ */ (function(DevicePlatform2) {
  DevicePlatform2["IOS"] = "ios";
  DevicePlatform2["ANDROID"] = "android";
  DevicePlatform2["WEB"] = "web";
  return DevicePlatform2;
})({});
var HrActionKind = /* @__PURE__ */ (function(HrActionKind2) {
  HrActionKind2["RESIGNATION"] = "resignation";
  HrActionKind2["LEAVE_OF_ABSENCE"] = "leave_of_absence";
  HrActionKind2["RETURN_FROM_LEAVE"] = "return_from_leave";
  HrActionKind2["HR_APPOINTMENT"] = "hr_appointment";
  HrActionKind2["SHIFT_CHANGE"] = "shift_change";
  return HrActionKind2;
})({});
var HrAppointmentAction = /* @__PURE__ */ (function(HrAppointmentAction2) {
  HrAppointmentAction2["TRANSFER"] = "transfer";
  HrAppointmentAction2["ADD_MEMBERSHIP"] = "add_membership";
  HrAppointmentAction2["END_MEMBERSHIP"] = "end_membership";
  HrAppointmentAction2["ROLE_CHANGE"] = "role_change";
  return HrAppointmentAction2;
})({});
var DocumentReviewAction = /* @__PURE__ */ (function(DocumentReviewAction2) {
  DocumentReviewAction2["APPROVED"] = "approved";
  DocumentReviewAction2["REJECTED"] = "rejected";
  return DocumentReviewAction2;
})({});

// src/enums/cs-report.enum.ts
var CsReportType = /* @__PURE__ */ (function(CsReportType2) {
  CsReportType2["BUG"] = "bug";
  CsReportType2["INCONVENIENCE"] = "inconvenience";
  CsReportType2["FEATURE_REQUEST"] = "feature_request";
  CsReportType2["QUESTION"] = "question";
  return CsReportType2;
})({});
var CsReportStatus = /* @__PURE__ */ (function(CsReportStatus2) {
  CsReportStatus2["RECEIVED"] = "received";
  CsReportStatus2["TRIAGED"] = "triaged";
  CsReportStatus2["IN_PROGRESS"] = "in_progress";
  CsReportStatus2["AWAITING_RELEASE"] = "awaiting_release";
  CsReportStatus2["RESOLVED"] = "resolved";
  CsReportStatus2["WONT_FIX"] = "wont_fix";
  CsReportStatus2["DUPLICATE"] = "duplicate";
  CsReportStatus2["CANCELLED"] = "cancelled";
  return CsReportStatus2;
})({});
var CsReportPriority = /* @__PURE__ */ (function(CsReportPriority2) {
  CsReportPriority2["LOW"] = "low";
  CsReportPriority2["NORMAL"] = "normal";
  CsReportPriority2["HIGH"] = "high";
  CsReportPriority2["URGENT"] = "urgent";
  return CsReportPriority2;
})({});
var CsReportSessionKind = /* @__PURE__ */ (function(CsReportSessionKind2) {
  CsReportSessionKind2["MEMBER"] = "member";
  CsReportSessionKind2["OWNER"] = "owner";
  CsReportSessionKind2["SUPPORT"] = "support";
  CsReportSessionKind2["IMPERSONATION"] = "impersonation";
  CsReportSessionKind2["SYSTEM"] = "system";
  return CsReportSessionKind2;
})({});
var CsReportApp = /* @__PURE__ */ (function(CsReportApp2) {
  CsReportApp2["ADMIN"] = "admin";
  CsReportApp2["HR_SYSTEM"] = "hr-system";
  CsReportApp2["EMPLOYEE_APP"] = "employee-app";
  CsReportApp2["TEAM_MANAGER"] = "team-manager";
  CsReportApp2["GENERAL_AFFAIRS"] = "general-affairs";
  CsReportApp2["MANAGEMENT_DASHBOARD"] = "management-dashboard";
  CsReportApp2["INVENTORY"] = "inventory";
  CsReportApp2["DRIVE"] = "drive";
  CsReportApp2["MODULE_MANAGER"] = "module-manager";
  return CsReportApp2;
})({});
var CsReportAttachmentKind = /* @__PURE__ */ (function(CsReportAttachmentKind2) {
  CsReportAttachmentKind2["SCREENSHOT"] = "screenshot";
  CsReportAttachmentKind2["LOG"] = "log";
  CsReportAttachmentKind2["USER_FILE"] = "user_file";
  return CsReportAttachmentKind2;
})({});
var CsReportCommentVisibility = /* @__PURE__ */ (function(CsReportCommentVisibility2) {
  CsReportCommentVisibility2["INTERNAL"] = "internal";
  CsReportCommentVisibility2["REPORTER"] = "reporter";
  return CsReportCommentVisibility2;
})({});
var CsReportCommentAuthorKind = /* @__PURE__ */ (function(CsReportCommentAuthorKind2) {
  CsReportCommentAuthorKind2["OPERATOR"] = "operator";
  CsReportCommentAuthorKind2["AGENT"] = "agent";
  return CsReportCommentAuthorKind2;
})({});
var CsReportTriageState = /* @__PURE__ */ (function(CsReportTriageState2) {
  CsReportTriageState2["PENDING"] = "pending";
  CsReportTriageState2["PROPOSED"] = "proposed";
  CsReportTriageState2["ACCEPTED"] = "accepted";
  CsReportTriageState2["EDITED"] = "edited";
  CsReportTriageState2["REJECTED"] = "rejected";
  CsReportTriageState2["SKIPPED"] = "skipped";
  return CsReportTriageState2;
})({});
var CsReportStatusActorKind = /* @__PURE__ */ (function(CsReportStatusActorKind2) {
  CsReportStatusActorKind2["REPORTER"] = "reporter";
  CsReportStatusActorKind2["OPERATOR"] = "operator";
  CsReportStatusActorKind2["SYSTEM"] = "system";
  return CsReportStatusActorKind2;
})({});

// src/enums/drive.enum.ts
var DriveAccessMode = /* @__PURE__ */ (function(DriveAccessMode2) {
  DriveAccessMode2["INHERIT"] = "inherit";
  DriveAccessMode2["RESTRICTED"] = "restricted";
  return DriveAccessMode2;
})({});
var DriveAccessRole = /* @__PURE__ */ (function(DriveAccessRole2) {
  DriveAccessRole2["VIEWER"] = "viewer";
  DriveAccessRole2["EDITOR"] = "editor";
  return DriveAccessRole2;
})({});
var DriveGranteeType = /* @__PURE__ */ (function(DriveGranteeType2) {
  DriveGranteeType2["TEAM"] = "team";
  DriveGranteeType2["EMPLOYEE"] = "employee";
  return DriveGranteeType2;
})({});
var DriveTargetType = /* @__PURE__ */ (function(DriveTargetType2) {
  DriveTargetType2["FOLDER"] = "folder";
  DriveTargetType2["FILE"] = "file";
  return DriveTargetType2;
})({});

// src/enums/e-sign.enum.ts
var ESignStatus = /* @__PURE__ */ (function(ESignStatus2) {
  ESignStatus2["SENDING"] = "sending";
  ESignStatus2["SENT"] = "sent";
  ESignStatus2["SIGNED"] = "signed";
  ESignStatus2["REJECTED"] = "rejected";
  ESignStatus2["EXPIRED"] = "expired";
  ESignStatus2["ERROR"] = "error";
  return ESignStatus2;
})({});
var ESignRemoteStatusCode = /* @__PURE__ */ (function(ESignRemoteStatusCode2) {
  ESignRemoteStatusCode2["WRITING"] = "writing";
  ESignRemoteStatusCode2["RESERVED"] = "reserved";
  ESignRemoteStatusCode2["RESERVE_FAILED"] = "reserve_failed";
  ESignRemoteStatusCode2["MY_INPUT_WAIT"] = "my_input_wait";
  ESignRemoteStatusCode2["SIGNER_WAITING"] = "signer_waiting";
  ESignRemoteStatusCode2["OTHER_INPUT_WAIT"] = "other_input_wait";
  ESignRemoteStatusCode2["IN_PROGRESS"] = "in_progress";
  ESignRemoteStatusCode2["AUTH_WAIT"] = "auth_wait";
  ESignRemoteStatusCode2["COMPLETED"] = "completed";
  ESignRemoteStatusCode2["DESTROYED"] = "destroyed";
  ESignRemoteStatusCode2["CANCELED"] = "canceled";
  return ESignRemoteStatusCode2;
})({});
var ESignFilterStatus = /* @__PURE__ */ (function(ESignFilterStatus2) {
  ESignFilterStatus2["WRITING"] = "writing";
  ESignFilterStatus2["RESERVED"] = "reserved";
  ESignFilterStatus2["FAILED"] = "failed";
  ESignFilterStatus2["WAITING"] = "waiting";
  ESignFilterStatus2["COMPLETED"] = "completed";
  ESignFilterStatus2["INACTIVE"] = "inactive";
  return ESignFilterStatus2;
})({});

// src/enums/employee.enum.ts
var EmployeeStatus = /* @__PURE__ */ (function(EmployeeStatus2) {
  EmployeeStatus2["ACTIVE"] = "ACTIVE";
  EmployeeStatus2["INACTIVE"] = "INACTIVE";
  EmployeeStatus2["ON_LEAVE"] = "ON_LEAVE";
  EmployeeStatus2["TERMINATED"] = "TERMINATED";
  return EmployeeStatus2;
})({});
var ContractType = /* @__PURE__ */ (function(ContractType2) {
  ContractType2["PERMANENT"] = "permanent";
  ContractType2["TEMPORARY"] = "temporary";
  ContractType2["CONTRACT"] = "contract";
  ContractType2["INTERNSHIP"] = "internship";
  ContractType2["PART_TIME"] = "part_time";
  ContractType2["FIXED_TERM"] = "fixed_term";
  ContractType2["CONTRACTOR"] = "contractor";
  ContractType2["CONSULTANT"] = "consultant";
  ContractType2["FREELANCE"] = "freelance";
  return ContractType2;
})({});
var WageType = /* @__PURE__ */ (function(WageType2) {
  WageType2["MONTHLY"] = "monthly";
  WageType2["HOURLY"] = "hourly";
  WageType2["DAILY"] = "daily";
  WageType2["ANNUAL"] = "annual";
  WageType2["WEEKLY"] = "weekly";
  WageType2["PROJECT"] = "project";
  WageType2["COMMISSION"] = "commission";
  return WageType2;
})({});
var CertificationType = /* @__PURE__ */ (function(CertificationType2) {
  CertificationType2["NURSING"] = "nursing";
  CertificationType2["NURSE_AIDE"] = "nurse_aide";
  CertificationType2["PHYSICAL_THERAPIST"] = "physical_therapist";
  CertificationType2["OCCUPATIONAL_THERAPIST"] = "occupational_therapist";
  CertificationType2["SPEECH_THERAPIST"] = "speech_therapist";
  CertificationType2["RADIOLOGIST"] = "radiologist";
  CertificationType2["CLINICAL_LAB"] = "clinical_lab";
  CertificationType2["PHARMACIST"] = "pharmacist";
  CertificationType2["DIETITIAN"] = "dietitian";
  CertificationType2["SOCIAL_WORKER"] = "social_worker";
  CertificationType2["MEDICAL_DOCTOR"] = "medical_doctor";
  CertificationType2["DENTIST"] = "dentist";
  CertificationType2["EMERGENCY_MEDICAL"] = "emergency_medical";
  CertificationType2["CARE_WORKER"] = "care_worker";
  CertificationType2["OTHER"] = "other";
  return CertificationType2;
})({});
var JobCategory = /* @__PURE__ */ (function(JobCategory2) {
  JobCategory2["NURSE"] = "nurse";
  JobCategory2["NURSE_AIDE"] = "nurse_aide";
  JobCategory2["CARE_WORKER"] = "care_worker";
  JobCategory2["WARD_SUPPORT"] = "ward_support";
  JobCategory2["PHYSICIAN"] = "physician";
  JobCategory2["THERAPIST"] = "therapist";
  JobCategory2["MEDICAL_TECHNICIAN"] = "medical_technician";
  JobCategory2["PHARMACIST"] = "pharmacist";
  JobCategory2["NUTRITION"] = "nutrition";
  JobCategory2["SOCIAL_WORKER"] = "social_worker";
  JobCategory2["ADMINISTRATION"] = "administration";
  JobCategory2["FACILITY"] = "facility";
  JobCategory2["OTHER"] = "other";
  return JobCategory2;
})({});
var ContractStatus = /* @__PURE__ */ (function(ContractStatus2) {
  ContractStatus2["DRAFT"] = "draft";
  ContractStatus2["PENDING_SIGNATURE"] = "pending_signature";
  ContractStatus2["ACTIVE"] = "active";
  ContractStatus2["EXPIRED"] = "expired";
  ContractStatus2["TERMINATED"] = "terminated";
  ContractStatus2["SUSPENDED"] = "suspended";
  ContractStatus2["RENEWED"] = "renewed";
  return ContractStatus2;
})({});
var ProbationStatus = /* @__PURE__ */ (function(ProbationStatus2) {
  ProbationStatus2["NOT_APPLICABLE"] = "not_applicable";
  ProbationStatus2["IN_PROGRESS"] = "in_progress";
  ProbationStatus2["PASSED"] = "passed";
  ProbationStatus2["FAILED"] = "failed";
  ProbationStatus2["EXTENDED"] = "extended";
  return ProbationStatus2;
})({});
var PayFrequency = /* @__PURE__ */ (function(PayFrequency2) {
  PayFrequency2["MONTHLY"] = "monthly";
  PayFrequency2["BIWEEKLY"] = "biweekly";
  PayFrequency2["WEEKLY"] = "weekly";
  PayFrequency2["DAILY"] = "daily";
  return PayFrequency2;
})({});
var SalaryIncreaseType = /* @__PURE__ */ (function(SalaryIncreaseType2) {
  SalaryIncreaseType2["PERCENTAGE"] = "percentage";
  SalaryIncreaseType2["FIXED"] = "fixed";
  return SalaryIncreaseType2;
})({});
var TerminationReason = /* @__PURE__ */ (function(TerminationReason2) {
  TerminationReason2["RESIGNATION"] = "resignation";
  TerminationReason2["DISMISSAL"] = "dismissal";
  TerminationReason2["MUTUAL_AGREEMENT"] = "mutual_agreement";
  TerminationReason2["END_OF_CONTRACT"] = "end_of_contract";
  TerminationReason2["RETIREMENT"] = "retirement";
  TerminationReason2["DEATH"] = "death";
  TerminationReason2["OTHER"] = "other";
  return TerminationReason2;
})({});
var AmendmentType = /* @__PURE__ */ (function(AmendmentType2) {
  AmendmentType2["SALARY_CHANGE"] = "salary_change";
  AmendmentType2["POSITION_CHANGE"] = "position_change";
  AmendmentType2["BENEFITS_CHANGE"] = "benefits_change";
  AmendmentType2["HOURS_CHANGE"] = "hours_change";
  AmendmentType2["LOCATION_CHANGE"] = "location_change";
  AmendmentType2["OTHER"] = "other";
  return AmendmentType2;
})({});

// src/enums/general-affairs.enum.ts
var TrainingCategory = /* @__PURE__ */ (function(TrainingCategory2) {
  TrainingCategory2["LEGAL_MANDATORY"] = "legal_mandatory";
  TrainingCategory2["ACCREDITATION"] = "accreditation";
  TrainingCategory2["SPECIALIZED"] = "specialized";
  TrainingCategory2["OTHER"] = "other";
  return TrainingCategory2;
})({});
var TrainingFrequency = /* @__PURE__ */ (function(TrainingFrequency2) {
  TrainingFrequency2["MONTHLY"] = "monthly";
  TrainingFrequency2["QUARTERLY"] = "quarterly";
  TrainingFrequency2["SEMI_ANNUAL"] = "semi_annual";
  TrainingFrequency2["ANNUAL"] = "annual";
  TrainingFrequency2["BIENNIAL"] = "biennial";
  TrainingFrequency2["TRIENNIAL"] = "triennial";
  return TrainingFrequency2;
})({});
var CompletionStatus = /* @__PURE__ */ (function(CompletionStatus2) {
  CompletionStatus2["COMPLETED"] = "completed";
  CompletionStatus2["EXPIRED"] = "expired";
  CompletionStatus2["UPCOMING"] = "upcoming";
  return CompletionStatus2;
})({});
var TaskCategory = /* @__PURE__ */ (function(TaskCategory2) {
  TaskCategory2["FACILITY"] = "facility";
  TaskCategory2["SAFETY"] = "safety";
  TaskCategory2["FIRE"] = "fire";
  TaskCategory2["HYGIENE"] = "hygiene";
  TaskCategory2["EQUIPMENT"] = "equipment";
  TaskCategory2["DOCUMENT"] = "document";
  TaskCategory2["COMPLIANCE"] = "compliance";
  TaskCategory2["OTHER"] = "other";
  return TaskCategory2;
})({});
var TaskFrequency = /* @__PURE__ */ (function(TaskFrequency2) {
  TaskFrequency2["DAILY"] = "daily";
  TaskFrequency2["WEEKLY"] = "weekly";
  TaskFrequency2["MONTHLY"] = "monthly";
  TaskFrequency2["QUARTERLY"] = "quarterly";
  TaskFrequency2["SEMI_ANNUAL"] = "semi_annual";
  TaskFrequency2["ANNUAL"] = "annual";
  return TaskFrequency2;
})({});
var ExecutionStatus = /* @__PURE__ */ (function(ExecutionStatus2) {
  ExecutionStatus2["PENDING"] = "pending";
  ExecutionStatus2["IN_PROGRESS"] = "in_progress";
  ExecutionStatus2["COMPLETED"] = "completed";
  ExecutionStatus2["OVERDUE"] = "overdue";
  ExecutionStatus2["SKIPPED"] = "skipped";
  return ExecutionStatus2;
})({});
var NoticeCategory = /* @__PURE__ */ (function(NoticeCategory2) {
  NoticeCategory2["TRAINING_DEADLINE"] = "training_deadline";
  NoticeCategory2["FACILITY"] = "facility";
  NoticeCategory2["SAFETY"] = "safety";
  NoticeCategory2["POLICY"] = "policy";
  NoticeCategory2["GENERAL"] = "general";
  return NoticeCategory2;
})({});
var NoticePriority = /* @__PURE__ */ (function(NoticePriority2) {
  NoticePriority2["LOW"] = "low";
  NoticePriority2["NORMAL"] = "normal";
  NoticePriority2["HIGH"] = "high";
  NoticePriority2["URGENT"] = "urgent";
  return NoticePriority2;
})({});

// src/enums/incentive.enum.ts
var IncentiveCategory = /* @__PURE__ */ (function(IncentiveCategory2) {
  IncentiveCategory2["REHABILITATION"] = "rehabilitation";
  IncentiveCategory2["NURSING"] = "nursing";
  IncentiveCategory2["SPORTS_MEDICINE"] = "sports_medicine";
  IncentiveCategory2["HOME_VISIT"] = "home_visit";
  IncentiveCategory2["ASSESSMENT"] = "assessment";
  IncentiveCategory2["ON_CALL"] = "on_call";
  IncentiveCategory2["OTHER"] = "other";
  return IncentiveCategory2;
})({});
var FixedIncentiveStatus = /* @__PURE__ */ (function(FixedIncentiveStatus2) {
  FixedIncentiveStatus2["PENDING"] = "pending";
  FixedIncentiveStatus2["APPROVED"] = "approved";
  FixedIncentiveStatus2["PAID"] = "paid";
  FixedIncentiveStatus2["CANCELLED"] = "cancelled";
  FixedIncentiveStatus2["REJECTED"] = "rejected";
  return FixedIncentiveStatus2;
})({});
var SubsidyStatus = /* @__PURE__ */ (function(SubsidyStatus2) {
  SubsidyStatus2["PENDING"] = "pending";
  SubsidyStatus2["APPROVED"] = "approved";
  SubsidyStatus2["PAID"] = "paid";
  SubsidyStatus2["CANCELLED"] = "cancelled";
  return SubsidyStatus2;
})({});
var ResignationStatus = /* @__PURE__ */ (function(ResignationStatus2) {
  ResignationStatus2["PENDING"] = "pending";
  ResignationStatus2["PROCESSING"] = "processing";
  ResignationStatus2["SETTLED"] = "settled";
  ResignationStatus2["COMPLETED"] = "completed";
  return ResignationStatus2;
})({});
var SettlementStatus = /* @__PURE__ */ (function(SettlementStatus2) {
  SettlementStatus2["PENDING"] = "pending";
  SettlementStatus2["CALCULATED"] = "calculated";
  SettlementStatus2["APPROVED"] = "approved";
  SettlementStatus2["APPLIED"] = "applied";
  SettlementStatus2["COMPLETED"] = "completed";
  return SettlementStatus2;
})({});
var TreatmentSessionRequestStatus = /* @__PURE__ */ (function(TreatmentSessionRequestStatus2) {
  TreatmentSessionRequestStatus2["PENDING"] = "pending";
  TreatmentSessionRequestStatus2["APPROVED"] = "approved";
  TreatmentSessionRequestStatus2["REJECTED"] = "rejected";
  TreatmentSessionRequestStatus2["CANCELLED"] = "cancelled";
  return TreatmentSessionRequestStatus2;
})({});

// src/enums/inquiry.enum.ts
var HospitalSize = /* @__PURE__ */ (function(HospitalSize2) {
  HospitalSize2["UNDER_50"] = "under_50";
  HospitalSize2["FROM_50_TO_150"] = "50_150";
  HospitalSize2["FROM_150_TO_500"] = "150_500";
  HospitalSize2["OVER_500"] = "over_500";
  return HospitalSize2;
})({});
var InquiryPain = /* @__PURE__ */ (function(InquiryPain2) {
  InquiryPain2["PAYROLL"] = "payroll";
  InquiryPain2["SCHEDULE"] = "schedule";
  InquiryPain2["DASHBOARD"] = "dashboard";
  InquiryPain2["STAFFING"] = "staffing";
  InquiryPain2["ATTENDANCE"] = "attendance";
  InquiryPain2["APPROVAL"] = "approval";
  InquiryPain2["EXCEL"] = "excel";
  InquiryPain2["LEGAL"] = "legal";
  InquiryPain2["DIGITAL"] = "digital";
  InquiryPain2["CURIOUS"] = "curious";
  return InquiryPain2;
})({});

// src/enums/integration.enum.ts
var IntegrationProvider = /* @__PURE__ */ (function(IntegrationProvider2) {
  IntegrationProvider2["HEREBY_SIGN"] = "hereby_sign";
  return IntegrationProvider2;
})({});
var IntegrationCredentialStatus = /* @__PURE__ */ (function(IntegrationCredentialStatus2) {
  IntegrationCredentialStatus2["ACTIVE"] = "active";
  IntegrationCredentialStatus2["INACTIVE"] = "inactive";
  return IntegrationCredentialStatus2;
})({});
var IntegrationWebhookSecretStatus = /* @__PURE__ */ (function(IntegrationWebhookSecretStatus2) {
  IntegrationWebhookSecretStatus2["ACTIVE"] = "active";
  IntegrationWebhookSecretStatus2["INACTIVE"] = "inactive";
  return IntegrationWebhookSecretStatus2;
})({});
var ExternalIntegrationProvisioningStatus = /* @__PURE__ */ (function(ExternalIntegrationProvisioningStatus2) {
  ExternalIntegrationProvisioningStatus2["PROVISIONING"] = "provisioning";
  ExternalIntegrationProvisioningStatus2["SUCCEEDED"] = "succeeded";
  ExternalIntegrationProvisioningStatus2["FAILED"] = "failed";
  ExternalIntegrationProvisioningStatus2["REVOKED"] = "revoked";
  return ExternalIntegrationProvisioningStatus2;
})({});
var IntegrationHealthStatus = /* @__PURE__ */ (function(IntegrationHealthStatus2) {
  IntegrationHealthStatus2["HEALTHY"] = "healthy";
  IntegrationHealthStatus2["WAITING"] = "waiting";
  IntegrationHealthStatus2["ERROR"] = "error";
  return IntegrationHealthStatus2;
})({});

// src/enums/leave.enum.ts
var LeaveType = /* @__PURE__ */ (function(LeaveType2) {
  LeaveType2["ANNUAL"] = "annual";
  LeaveType2["SICK"] = "sick";
  LeaveType2["PERSONAL"] = "personal";
  LeaveType2["MATERNITY"] = "maternity";
  LeaveType2["PATERNITY"] = "paternity";
  LeaveType2["BEREAVEMENT"] = "bereavement";
  LeaveType2["MILITARY"] = "military";
  LeaveType2["OTHER"] = "other";
  return LeaveType2;
})({});
var LeaveStatus = /* @__PURE__ */ (function(LeaveStatus2) {
  LeaveStatus2["PENDING"] = "pending";
  LeaveStatus2["APPROVED"] = "approved";
  LeaveStatus2["REJECTED"] = "rejected";
  LeaveStatus2["CANCELLED"] = "cancelled";
  return LeaveStatus2;
})({});
var HalfDayPeriod = /* @__PURE__ */ (function(HalfDayPeriod2) {
  HalfDayPeriod2["MORNING"] = "morning";
  HalfDayPeriod2["AFTERNOON"] = "afternoon";
  return HalfDayPeriod2;
})({});
var LeaveOfAbsenceStatus = /* @__PURE__ */ (function(LeaveOfAbsenceStatus2) {
  LeaveOfAbsenceStatus2["ACTIVE"] = "active";
  LeaveOfAbsenceStatus2["RETURNED"] = "returned";
  LeaveOfAbsenceStatus2["CANCELLED"] = "cancelled";
  return LeaveOfAbsenceStatus2;
})({});
var AccrualType = /* @__PURE__ */ (function(AccrualType2) {
  AccrualType2["MONTHLY"] = "monthly";
  AccrualType2["ANNUAL"] = "annual";
  return AccrualType2;
})({});
var LeaveAccrualBasis = /* @__PURE__ */ (function(LeaveAccrualBasis2) {
  LeaveAccrualBasis2["FISCAL_YEAR"] = "fiscal_year";
  LeaveAccrualBasis2["HIRE_DATE"] = "hire_date";
  return LeaveAccrualBasis2;
})({});
var FiscalNewHireMode = /* @__PURE__ */ (function(FiscalNewHireMode2) {
  FiscalNewHireMode2["PRORATE_IN_HIRE_YEAR"] = "prorate_in_hire_year";
  FiscalNewHireMode2["MONTHLY_THEN_RETROACTIVE"] = "monthly_then_retroactive";
  FiscalNewHireMode2["MONTHLY_THEN_PRORATE_AT_ANNIVERSARY"] = "monthly_then_prorate_at_anniversary";
  return FiscalNewHireMode2;
})({});
var LeaveLedgerEntryType = /* @__PURE__ */ (function(LeaveLedgerEntryType2) {
  LeaveLedgerEntryType2["OPENING_BALANCE"] = "opening_balance";
  LeaveLedgerEntryType2["GRANT"] = "grant";
  LeaveLedgerEntryType2["USE"] = "use";
  LeaveLedgerEntryType2["CARRYOVER"] = "carryover";
  LeaveLedgerEntryType2["EXPIRE"] = "expire";
  LeaveLedgerEntryType2["CONVERT"] = "convert";
  LeaveLedgerEntryType2["ADJUST"] = "adjust";
  LeaveLedgerEntryType2["NEGATIVE_CARRY"] = "negative_carry";
  return LeaveLedgerEntryType2;
})({});
var LeaveDeductionMode = /* @__PURE__ */ (function(LeaveDeductionMode2) {
  LeaveDeductionMode2["FIXED_DAYS"] = "fixed_days";
  LeaveDeductionMode2["DUTY"] = "duty";
  return LeaveDeductionMode2;
})({});
var HolidayWorkMode = /* @__PURE__ */ (function(HolidayWorkMode2) {
  HolidayWorkMode2["PREMIUM_PAY"] = "premium_pay";
  HolidayWorkMode2["HOLIDAY_SUBSTITUTION"] = "holiday_substitution";
  return HolidayWorkMode2;
})({});
var LeaveImportFormat = /* @__PURE__ */ (function(LeaveImportFormat2) {
  LeaveImportFormat2["HEREBY"] = "hereby";
  LeaveImportFormat2["ECOUNT"] = "ecount";
  LeaveImportFormat2["SHEET"] = "sheet";
  return LeaveImportFormat2;
})({});
var LeaveImportTerminatedPolicy = /* @__PURE__ */ (function(LeaveImportTerminatedPolicy2) {
  LeaveImportTerminatedPolicy2["CREATE"] = "create";
  LeaveImportTerminatedPolicy2["SKIP"] = "skip";
  LeaveImportTerminatedPolicy2["ERROR"] = "error";
  return LeaveImportTerminatedPolicy2;
})({});
var LeaveImportBatchStatus = /* @__PURE__ */ (function(LeaveImportBatchStatus2) {
  LeaveImportBatchStatus2["APPLIED"] = "applied";
  LeaveImportBatchStatus2["REVERTED"] = "reverted";
  return LeaveImportBatchStatus2;
})({});

// src/enums/notification.enum.ts
var NotificationType = /* @__PURE__ */ (function(NotificationType2) {
  NotificationType2["LEAVE_REQUEST"] = "leave_request";
  NotificationType2["ATTENDANCE_CORRECTION"] = "attendance_correction";
  NotificationType2["OVERTIME"] = "overtime";
  NotificationType2["OFFSITE_WORK"] = "offsite_work";
  NotificationType2["INCENTIVE"] = "incentive";
  NotificationType2["ALLOWANCE"] = "allowance";
  NotificationType2["DEDUCTION"] = "deduction";
  NotificationType2["DOCUMENT"] = "document";
  NotificationType2["EDUCATION"] = "education";
  NotificationType2["CERTIFICATE"] = "certificate";
  NotificationType2["PERMISSION_REQUEST"] = "permission_request";
  NotificationType2["GENERAL"] = "general";
  NotificationType2["SYSTEM"] = "system";
  NotificationType2["MEMO"] = "memo";
  NotificationType2["MESSAGE"] = "message";
  return NotificationType2;
})({});
var NotificationAction = /* @__PURE__ */ (function(NotificationAction2) {
  NotificationAction2["CREATED"] = "created";
  NotificationAction2["APPROVED"] = "approved";
  NotificationAction2["REJECTED"] = "rejected";
  NotificationAction2["CANCELLED"] = "cancelled";
  NotificationAction2["UPDATED"] = "updated";
  NotificationAction2["REMINDER"] = "reminder";
  return NotificationAction2;
})({});
var DeliveryChannel = /* @__PURE__ */ (function(DeliveryChannel2) {
  DeliveryChannel2["IN_APP"] = "in_app";
  DeliveryChannel2["PUSH"] = "push";
  DeliveryChannel2["EMAIL"] = "email";
  DeliveryChannel2["SMS"] = "sms";
  return DeliveryChannel2;
})({});
var DeliveryStatus = /* @__PURE__ */ (function(DeliveryStatus2) {
  DeliveryStatus2["PENDING"] = "pending";
  DeliveryStatus2["SENT"] = "sent";
  DeliveryStatus2["DELIVERED"] = "delivered";
  DeliveryStatus2["FAILED"] = "failed";
  return DeliveryStatus2;
})({});
var NotificationMuteType = /* @__PURE__ */ (function(NotificationMuteType2) {
  NotificationMuteType2["EMPLOYEE"] = "employee";
  NotificationMuteType2["TEAM"] = "team";
  NotificationMuteType2["EVENT_TYPE"] = "event_type";
  NotificationMuteType2["ALL"] = "all";
  return NotificationMuteType2;
})({});
var NotificationPushCategory = /* @__PURE__ */ (function(NotificationPushCategory2) {
  NotificationPushCategory2["MESSENGER"] = "messenger";
  NotificationPushCategory2["APPROVAL_REQUEST"] = "approval_request";
  NotificationPushCategory2["APPROVAL_RESULT"] = "approval_result";
  NotificationPushCategory2["NOTICE"] = "notice";
  NotificationPushCategory2["ATTENDANCE"] = "attendance";
  NotificationPushCategory2["PAYSLIP"] = "payslip";
  NotificationPushCategory2["OTHER"] = "other";
  return NotificationPushCategory2;
})({});

// src/enums/nurse.enum.ts
var NurseWorkType = /* @__PURE__ */ (function(NurseWorkType2) {
  NurseWorkType2["THREE_SHIFT"] = "three_shift";
  NurseWorkType2["NIGHT_DEDICATED"] = "night_dedicated";
  NurseWorkType2["DAY_DEDICATED"] = "day_dedicated";
  NurseWorkType2["EVENING_DEDICATED"] = "evening_dedicated";
  return NurseWorkType2;
})({});
var AssignmentType = /* @__PURE__ */ (function(AssignmentType2) {
  AssignmentType2["DAY"] = "day";
  AssignmentType2["EVENING"] = "evening";
  AssignmentType2["NIGHT"] = "night";
  AssignmentType2["DAY_EDUCATION"] = "day_education";
  AssignmentType2["EVENING_EDUCATION"] = "evening_education";
  AssignmentType2["NIGHT_EDUCATION"] = "night_education";
  AssignmentType2["OFF"] = "off";
  AssignmentType2["ANNUAL_LEAVE"] = "annual_leave";
  AssignmentType2["SICK_LEAVE"] = "sick_leave";
  AssignmentType2["BEREAVEMENT"] = "bereavement";
  AssignmentType2["EDUCATION_OFF"] = "education_off";
  AssignmentType2["UNAVAILABLE"] = "unavailable";
  AssignmentType2["HALF_DAY"] = "half_day";
  AssignmentType2["LEAVE_CUSTOM"] = "leave_custom";
  AssignmentType2["SHIFT_CUSTOM"] = "shift_custom";
  AssignmentType2["EDUCATION"] = "education";
  return AssignmentType2;
})({});
var ScheduleStatus = /* @__PURE__ */ (function(ScheduleStatus2) {
  ScheduleStatus2["DRAFT"] = "draft";
  ScheduleStatus2["GENERATING"] = "generating";
  ScheduleStatus2["AI_GENERATED"] = "ai_generated";
  ScheduleStatus2["EDITING"] = "editing";
  ScheduleStatus2["CONFIRMED"] = "confirmed";
  ScheduleStatus2["PUBLISHED"] = "published";
  return ScheduleStatus2;
})({});
var PreferenceStatus = /* @__PURE__ */ (function(PreferenceStatus2) {
  PreferenceStatus2["DRAFT"] = "draft";
  PreferenceStatus2["SUBMITTED"] = "submitted";
  return PreferenceStatus2;
})({});
var WorkTypeChangeStatus = /* @__PURE__ */ (function(WorkTypeChangeStatus2) {
  WorkTypeChangeStatus2["PENDING"] = "pending";
  WorkTypeChangeStatus2["APPROVED"] = "approved";
  WorkTypeChangeStatus2["REJECTED"] = "rejected";
  WorkTypeChangeStatus2["CANCELLED"] = "cancelled";
  return WorkTypeChangeStatus2;
})({});
var NurseWardReservationStatus = /* @__PURE__ */ (function(NurseWardReservationStatus2) {
  NurseWardReservationStatus2["PENDING"] = "pending";
  NurseWardReservationStatus2["APPLIED"] = "applied";
  NurseWardReservationStatus2["CANCELLED"] = "cancelled";
  return NurseWardReservationStatus2;
})({});
var WardCareType = /* @__PURE__ */ (function(WardCareType2) {
  WardCareType2["GENERAL"] = "general";
  WardCareType2["REHAB"] = "rehab";
  return WardCareType2;
})({});
var WardPatientCountSource = /* @__PURE__ */ (function(WardPatientCountSource2) {
  WardPatientCountSource2["MEASURED"] = "measured";
  WardPatientCountSource2["ESTIMATED"] = "estimated";
  WardPatientCountSource2["BULK"] = "bulk";
  return WardPatientCountSource2;
})({});

// src/enums/offsite-work.enum.ts
var OffsiteWorkStatus = /* @__PURE__ */ (function(OffsiteWorkStatus2) {
  OffsiteWorkStatus2["PENDING"] = "pending";
  OffsiteWorkStatus2["APPROVED"] = "approved";
  OffsiteWorkStatus2["REJECTED"] = "rejected";
  OffsiteWorkStatus2["CANCELLED"] = "cancelled";
  OffsiteWorkStatus2["REPORT_PENDING"] = "report_pending";
  OffsiteWorkStatus2["REPORT_APPROVED"] = "report_approved";
  OffsiteWorkStatus2["REPORT_REJECTED"] = "report_rejected";
  return OffsiteWorkStatus2;
})({});

// src/enums/organization.enum.ts
var OrganizationStatus = /* @__PURE__ */ (function(OrganizationStatus2) {
  OrganizationStatus2["ACTIVE"] = "ACTIVE";
  OrganizationStatus2["INACTIVE"] = "INACTIVE";
  OrganizationStatus2["SUSPENDED"] = "SUSPENDED";
  OrganizationStatus2["TRIAL"] = "TRIAL";
  return OrganizationStatus2;
})({});
var OrganizationType = /* @__PURE__ */ (function(OrganizationType2) {
  OrganizationType2["CLINIC"] = "CLINIC";
  OrganizationType2["HOSPITAL"] = "HOSPITAL";
  OrganizationType2["GENERAL_HOSPITAL"] = "GENERAL_HOSPITAL";
  OrganizationType2["TERTIARY_HOSPITAL"] = "TERTIARY_HOSPITAL";
  OrganizationType2["LONG_TERM_CARE_HOSPITAL"] = "LONG_TERM_CARE_HOSPITAL";
  OrganizationType2["MENTAL_HOSPITAL"] = "MENTAL_HOSPITAL";
  OrganizationType2["DENTAL_HOSPITAL"] = "DENTAL_HOSPITAL";
  OrganizationType2["ORIENTAL_HOSPITAL"] = "ORIENTAL_HOSPITAL";
  OrganizationType2["MIDWIFERY_CENTER"] = "MIDWIFERY_CENTER";
  OrganizationType2["OTHER"] = "OTHER";
  return OrganizationType2;
})({});
var OrganizationSize = /* @__PURE__ */ (function(OrganizationSize2) {
  OrganizationSize2["SMALL"] = "SMALL";
  OrganizationSize2["MEDIUM"] = "MEDIUM";
  OrganizationSize2["LARGE"] = "LARGE";
  OrganizationSize2["XLARGE"] = "XLARGE";
  return OrganizationSize2;
})({});
var RoleType = /* @__PURE__ */ (function(RoleType2) {
  RoleType2["SYSTEM"] = "system";
  RoleType2["TEAM"] = "team";
  RoleType2["CUSTOM"] = "custom";
  return RoleType2;
})({});
var PermissionType = /* @__PURE__ */ (function(PermissionType2) {
  PermissionType2["READ"] = "read";
  PermissionType2["WRITE"] = "write";
  PermissionType2["DELETE"] = "delete";
  PermissionType2["EXECUTE"] = "execute";
  PermissionType2["APPROVE"] = "approve";
  PermissionType2["MANAGE"] = "manage";
  return PermissionType2;
})({});
var RoleStatus = /* @__PURE__ */ (function(RoleStatus2) {
  RoleStatus2["ACTIVE"] = "active";
  RoleStatus2["INACTIVE"] = "inactive";
  RoleStatus2["DEPRECATED"] = "deprecated";
  return RoleStatus2;
})({});
var PermissionActionType = /* @__PURE__ */ (function(PermissionActionType2) {
  PermissionActionType2["CREATE"] = "create";
  PermissionActionType2["READ"] = "read";
  PermissionActionType2["UPDATE"] = "update";
  PermissionActionType2["DELETE"] = "delete";
  PermissionActionType2["EXECUTE"] = "execute";
  PermissionActionType2["APPROVE"] = "approve";
  PermissionActionType2["EXPORT"] = "export";
  PermissionActionType2["IMPORT"] = "import";
  return PermissionActionType2;
})({});
var ResourceType = /* @__PURE__ */ (function(ResourceType2) {
  ResourceType2["ORGANIZATION"] = "organization";
  ResourceType2["TEAM"] = "team";
  ResourceType2["EMPLOYEE"] = "employee";
  ResourceType2["CONTRACT"] = "contract";
  ResourceType2["PAYROLL"] = "payroll";
  ResourceType2["ATTENDANCE"] = "attendance";
  ResourceType2["SHIFT"] = "shift";
  ResourceType2["LEAVE"] = "leave";
  ResourceType2["REPORT"] = "report";
  ResourceType2["SETTING"] = "setting";
  ResourceType2["ROLE"] = "role";
  ResourceType2["PERMISSION"] = "permission";
  ResourceType2["AUDIT"] = "audit";
  ResourceType2["NOTIFICATION"] = "notification";
  ResourceType2["INTEGRATION"] = "integration";
  ResourceType2["ALL"] = "all";
  return ResourceType2;
})({});
var PermissionScope = /* @__PURE__ */ (function(PermissionScope2) {
  PermissionScope2["SELF"] = "self";
  PermissionScope2["TEAM"] = "team";
  PermissionScope2["ALL"] = "all";
  return PermissionScope2;
})({});
var TeamPermissionScope = /* @__PURE__ */ (function(TeamPermissionScope2) {
  TeamPermissionScope2["TEAM"] = "team";
  TeamPermissionScope2["SELF"] = "self";
  return TeamPermissionScope2;
})({});
var PermissionAuditAction = /* @__PURE__ */ (function(PermissionAuditAction2) {
  PermissionAuditAction2["CREATE"] = "create";
  PermissionAuditAction2["UPDATE"] = "update";
  PermissionAuditAction2["DELETE"] = "delete";
  PermissionAuditAction2["ASSIGN"] = "assign";
  PermissionAuditAction2["REVOKE"] = "revoke";
  return PermissionAuditAction2;
})({});
var PermissionAuditEntityType = /* @__PURE__ */ (function(PermissionAuditEntityType2) {
  PermissionAuditEntityType2["ROLE"] = "role";
  PermissionAuditEntityType2["PERMISSION"] = "permission";
  PermissionAuditEntityType2["TEAM_PERMISSION"] = "team_permission";
  return PermissionAuditEntityType2;
})({});
var RoleAssignmentOperation = /* @__PURE__ */ (function(RoleAssignmentOperation2) {
  RoleAssignmentOperation2["ASSIGN"] = "assign";
  RoleAssignmentOperation2["REVOKE"] = "revoke";
  return RoleAssignmentOperation2;
})({});
var OrganizationSortBy = /* @__PURE__ */ (function(OrganizationSortBy2) {
  OrganizationSortBy2["NAME"] = "name";
  OrganizationSortBy2["CREATED_AT"] = "createdAt";
  OrganizationSortBy2["SIZE"] = "size";
  OrganizationSortBy2["STATUS"] = "status";
  return OrganizationSortBy2;
})({});
var ContractSortBy = /* @__PURE__ */ (function(ContractSortBy2) {
  ContractSortBy2["START_DATE"] = "startDate";
  ContractSortBy2["END_DATE"] = "endDate";
  ContractSortBy2["BASE_SALARY"] = "baseSalary";
  ContractSortBy2["EMPLOYEE_NAME"] = "employeeName";
  ContractSortBy2["STATUS"] = "status";
  ContractSortBy2["CREATED_AT"] = "createdAt";
  return ContractSortBy2;
})({});
var EmployeeHomeSection = /* @__PURE__ */ (function(EmployeeHomeSection2) {
  EmployeeHomeSection2["CELEBRATIONS"] = "celebrations";
  EmployeeHomeSection2["NOTICES"] = "notices";
  EmployeeHomeSection2["WEEKLY_ATTENDANCE"] = "weeklyAttendance";
  return EmployeeHomeSection2;
})({});
var SheetContractBasis = /* @__PURE__ */ (function(SheetContractBasis2) {
  SheetContractBasis2["PRORATE"] = "prorate";
  SheetContractBasis2["LAST_CONTRACT"] = "last_contract";
  return SheetContractBasis2;
})({});

// src/enums/overtime.enum.ts
var OvertimeCategory = /* @__PURE__ */ (function(OvertimeCategory2) {
  OvertimeCategory2["WEEKDAY"] = "weekday";
  OvertimeCategory2["SATURDAY"] = "saturday";
  OvertimeCategory2["HOLIDAY"] = "holiday";
  OvertimeCategory2["NIGHT"] = "night";
  OvertimeCategory2["HOLIDAY_NIGHT"] = "holiday_night";
  return OvertimeCategory2;
})({});
var OvertimeStatus = /* @__PURE__ */ (function(OvertimeStatus2) {
  OvertimeStatus2["PENDING"] = "pending";
  OvertimeStatus2["APPROVED"] = "approved";
  OvertimeStatus2["REJECTED"] = "rejected";
  OvertimeStatus2["CANCELLED"] = "cancelled";
  OvertimeStatus2["REPORT_PENDING"] = "report_pending";
  OvertimeStatus2["REPORT_APPROVED"] = "report_approved";
  OvertimeStatus2["REPORT_REJECTED"] = "report_rejected";
  return OvertimeStatus2;
})({});

// src/enums/payroll.enum.ts
var PayrollStatus = /* @__PURE__ */ (function(PayrollStatus2) {
  PayrollStatus2["DRAFT"] = "draft";
  PayrollStatus2["CALCULATED"] = "calculated";
  PayrollStatus2["APPROVED"] = "approved";
  PayrollStatus2["CONFIRMED"] = "confirmed";
  PayrollStatus2["PAID"] = "paid";
  PayrollStatus2["CANCELLED"] = "cancelled";
  PayrollStatus2["CORRECTED"] = "corrected";
  return PayrollStatus2;
})({});
var PayrollSourceType = /* @__PURE__ */ (function(PayrollSourceType2) {
  PayrollSourceType2["EMPLOYMENT_CONTRACT"] = "employment_contract";
  PayrollSourceType2["OVERTIME_RECORD"] = "overtime_record";
  PayrollSourceType2["FIXED_INCENTIVE"] = "fixed_incentive";
  PayrollSourceType2["EDUCATION_SUBSIDY"] = "education_subsidy";
  PayrollSourceType2["YEAR_END_SETTLEMENT"] = "year_end_settlement";
  PayrollSourceType2["RESIGNATION_RECORD"] = "resignation_record";
  PayrollSourceType2["PAYROLL_RATE_CONFIG"] = "payroll_rate_config";
  PayrollSourceType2["TAX_BRACKET_CONFIG"] = "tax_bracket_config";
  PayrollSourceType2["MANUAL"] = "manual";
  return PayrollSourceType2;
})({});
var SourceModule = /* @__PURE__ */ (function(SourceModule2) {
  SourceModule2["EMPLOYMENT_CONTRACT"] = "employment_contract";
  SourceModule2["OVERTIME_RECORD"] = "overtime_record";
  SourceModule2["FIXED_INCENTIVE"] = "fixed_incentive";
  SourceModule2["EDUCATION_SUBSIDY"] = "education_subsidy";
  SourceModule2["YEAR_END_SETTLEMENT"] = "year_end_settlement";
  SourceModule2["RESIGNATION_RECORD"] = "resignation_record";
  SourceModule2["PAYROLL_RATE_CONFIG"] = "payroll_rate_config";
  SourceModule2["TAX_BRACKET_CONFIG"] = "tax_bracket_config";
  SourceModule2["MANUAL"] = "manual";
  return SourceModule2;
})({});
var AllowanceSubCategory = /* @__PURE__ */ (function(AllowanceSubCategory2) {
  AllowanceSubCategory2["STRUCTURAL"] = "structural";
  AllowanceSubCategory2["CELEBRATION"] = "celebration";
  AllowanceSubCategory2["LEGACY"] = "legacy";
  AllowanceSubCategory2["TEMPORARY"] = "temporary";
  return AllowanceSubCategory2;
})({});
var TaxExemptType = /* @__PURE__ */ (function(TaxExemptType2) {
  TaxExemptType2["MEAL"] = "meal";
  TaxExemptType2["VEHICLE"] = "vehicle";
  TaxExemptType2["CHILDCARE"] = "childcare";
  TaxExemptType2["RESEARCH"] = "research";
  TaxExemptType2["NIGHT_WORK"] = "night_work";
  TaxExemptType2["OTHER"] = "other";
  return TaxExemptType2;
})({});
var DeductionExclusionReason = /* @__PURE__ */ (function(DeductionExclusionReason2) {
  DeductionExclusionReason2["AGE_60"] = "age_60";
  DeductionExclusionReason2["SHORT_TIME"] = "short_time";
  DeductionExclusionReason2["NEW_HIRE_65"] = "new_hire_65";
  DeductionExclusionReason2["DUAL_EMPLOYMENT"] = "dual_employment";
  DeductionExclusionReason2["MANUAL"] = "manual";
  DeductionExclusionReason2["OTHER"] = "other";
  return DeductionExclusionReason2;
})({});
var DeductionSettlementState = /* @__PURE__ */ (function(DeductionSettlementState2) {
  DeductionSettlementState2["PROVISIONAL"] = "provisional";
  DeductionSettlementState2["FINAL"] = "final";
  return DeductionSettlementState2;
})({});
var DeductionSubCategory = /* @__PURE__ */ (function(DeductionSubCategory2) {
  DeductionSubCategory2["STATUTORY"] = "statutory";
  DeductionSubCategory2["WELFARE_LOAN"] = "welfare_loan";
  DeductionSubCategory2["DORMITORY"] = "dormitory";
  DeductionSubCategory2["VOLUNTARY"] = "voluntary";
  DeductionSubCategory2["LEGACY"] = "legacy";
  return DeductionSubCategory2;
})({});
var CellMemoStatus = /* @__PURE__ */ (function(CellMemoStatus2) {
  CellMemoStatus2["OPEN"] = "open";
  CellMemoStatus2["RESOLVED"] = "resolved";
  return CellMemoStatus2;
})({});
var PaymentMethod = /* @__PURE__ */ (function(PaymentMethod2) {
  PaymentMethod2["SALARY"] = "salary";
  PaymentMethod2["MOBILE_GIFT"] = "mobile_gift";
  PaymentMethod2["CASH"] = "cash";
  return PaymentMethod2;
})({});
var AllowanceStatus = /* @__PURE__ */ (function(AllowanceStatus2) {
  AllowanceStatus2["PENDING"] = "pending";
  AllowanceStatus2["APPROVED"] = "approved";
  AllowanceStatus2["PAID"] = "paid";
  AllowanceStatus2["CANCELLED"] = "cancelled";
  return AllowanceStatus2;
})({});
var DeductionStatus = /* @__PURE__ */ (function(DeductionStatus2) {
  DeductionStatus2["PENDING"] = "pending";
  DeductionStatus2["APPROVED"] = "approved";
  DeductionStatus2["APPLIED"] = "applied";
  DeductionStatus2["CANCELLED"] = "cancelled";
  return DeductionStatus2;
})({});
var SalaryGradeCategory = /* @__PURE__ */ (function(SalaryGradeCategory2) {
  SalaryGradeCategory2["REHABILITATION"] = "rehabilitation";
  SalaryGradeCategory2["FUNCTIONAL"] = "functional";
  SalaryGradeCategory2["NURSING"] = "nursing";
  return SalaryGradeCategory2;
})({});
var SalaryGradeStatus = /* @__PURE__ */ (function(SalaryGradeStatus2) {
  SalaryGradeStatus2["ACTIVE"] = "active";
  SalaryGradeStatus2["INACTIVE"] = "inactive";
  return SalaryGradeStatus2;
})({});
var ProcessPaymentMethod = /* @__PURE__ */ (function(ProcessPaymentMethod2) {
  ProcessPaymentMethod2["BANK_TRANSFER"] = "bank_transfer";
  ProcessPaymentMethod2["CASH"] = "cash";
  ProcessPaymentMethod2["CHECK"] = "check";
  return ProcessPaymentMethod2;
})({});
var PromotionStatus = /* @__PURE__ */ (function(PromotionStatus2) {
  PromotionStatus2["PENDING"] = "pending";
  PromotionStatus2["APPROVED"] = "approved";
  PromotionStatus2["REJECTED"] = "rejected";
  PromotionStatus2["APPLIED"] = "applied";
  PromotionStatus2["SCHEDULED"] = "scheduled";
  return PromotionStatus2;
})({});
var PromotionType = /* @__PURE__ */ (function(PromotionType2) {
  PromotionType2["HIRE_ANNIVERSARY"] = "hire_anniversary";
  PromotionType2["FISCAL_YEAR"] = "fiscal_year";
  return PromotionType2;
})({});
var AllowanceType = /* @__PURE__ */ (function(AllowanceType2) {
  AllowanceType2["SPECIAL"] = "special";
  AllowanceType2["OTHER"] = "other";
  AllowanceType2["ADJUSTMENT"] = "adjustment";
  AllowanceType2["NURSING_INCENTIVE"] = "nursing_incentive";
  AllowanceType2["FIXED_INCENTIVE"] = "fixed_incentive";
  AllowanceType2["ON_CALL"] = "on_call";
  return AllowanceType2;
})({});

// src/enums/permission.enum.ts
var PermissionSortBy = /* @__PURE__ */ (function(PermissionSortBy2) {
  PermissionSortBy2["NAME"] = "name";
  PermissionSortBy2["CODE"] = "code";
  PermissionSortBy2["LEVEL"] = "level";
  PermissionSortBy2["TYPE"] = "type";
  PermissionSortBy2["CREATED_AT"] = "createdAt";
  return PermissionSortBy2;
})({});

// src/enums/scheduled-action.enum.ts
var ScheduledActionKind = /* @__PURE__ */ (function(ScheduledActionKind2) {
  ScheduledActionKind2["CONTRACT_CHANGE"] = "contract_change";
  ScheduledActionKind2["SHEET_CELL"] = "sheet_cell";
  ScheduledActionKind2["HR_ACTION"] = "hr_action";
  ScheduledActionKind2["LEAVE_BASIS_TRANSITION"] = "leave_basis_transition";
  ScheduledActionKind2["WORKTIME_AUTO_CLOSE"] = "worktime_auto_close";
  ScheduledActionKind2["LEAVE_PROMOTION"] = "leave_promotion";
  ScheduledActionKind2["NEW_EMPLOYEE_ROW"] = "new_employee_row";
  return ScheduledActionKind2;
})({});
var SCHEDULED_ACTION_RECORD_KINDS = [
  "hr_action",
  "leave_basis_transition",
  "worktime_auto_close",
  "leave_promotion",
  "new_employee_row"
];
function isScheduledActionRecordKind(kind) {
  return SCHEDULED_ACTION_RECORD_KINDS.includes(kind);
}
__name(isScheduledActionRecordKind, "isScheduledActionRecordKind");
var ScheduledActionGroupPolicy = /* @__PURE__ */ (function(ScheduledActionGroupPolicy2) {
  ScheduledActionGroupPolicy2["ALL_OR_NOTHING"] = "all_or_nothing";
  ScheduledActionGroupPolicy2["INDEPENDENT"] = "independent";
  return ScheduledActionGroupPolicy2;
})({});
var ScheduledChangeApplyPolicy = /* @__PURE__ */ (function(ScheduledChangeApplyPolicy2) {
  ScheduledChangeApplyPolicy2["AUTO"] = "auto";
  ScheduledChangeApplyPolicy2["CONFIRM"] = "confirm";
  return ScheduledChangeApplyPolicy2;
})({});
var ScheduledActionStatus = /* @__PURE__ */ (function(ScheduledActionStatus2) {
  ScheduledActionStatus2["SCHEDULED"] = "scheduled";
  ScheduledActionStatus2["PROPOSED"] = "proposed";
  ScheduledActionStatus2["APPLIED"] = "applied";
  ScheduledActionStatus2["FAILED"] = "failed";
  ScheduledActionStatus2["SKIPPED"] = "skipped";
  ScheduledActionStatus2["CANCELLED"] = "cancelled";
  return ScheduledActionStatus2;
})({});
var ScheduledActionOrigin = /* @__PURE__ */ (function(ScheduledActionOrigin2) {
  ScheduledActionOrigin2["USER"] = "user";
  ScheduledActionOrigin2["AI"] = "ai";
  ScheduledActionOrigin2["SYSTEM"] = "system";
  return ScheduledActionOrigin2;
})({});

// src/enums/screen-capture.enum.ts
var ScreenCaptureEventKind = /* @__PURE__ */ (function(ScreenCaptureEventKind2) {
  ScreenCaptureEventKind2["SCREENSHOT"] = "screenshot";
  ScreenCaptureEventKind2["RECORDING_STARTED"] = "recording_started";
  ScreenCaptureEventKind2["RECORDING_STOPPED"] = "recording_stopped";
  return ScreenCaptureEventKind2;
})({});
var ScreenCaptureScreen = /* @__PURE__ */ (function(ScreenCaptureScreen2) {
  ScreenCaptureScreen2["PAYSLIP"] = "payslip";
  ScreenCaptureScreen2["MY_INFO"] = "my_info";
  ScreenCaptureScreen2["MESSENGER"] = "messenger";
  return ScreenCaptureScreen2;
})({});

// src/enums/secom.enum.ts
var SecomEventStatus = /* @__PURE__ */ (function(SecomEventStatus2) {
  SecomEventStatus2["PENDING"] = "pending";
  SecomEventStatus2["PROCESSED"] = "processed";
  SecomEventStatus2["ERROR"] = "error";
  SecomEventStatus2["IGNORED"] = "ignored";
  return SecomEventStatus2;
})({});
var SecomEventType = /* @__PURE__ */ (function(SecomEventType2) {
  SecomEventType2["CHECK_IN"] = "check_in";
  SecomEventType2["CHECK_OUT"] = "check_out";
  SecomEventType2["UNKNOWN"] = "unknown";
  return SecomEventType2;
})({});
var SecomEventOrigin = /* @__PURE__ */ (function(SecomEventOrigin2) {
  SecomEventOrigin2["GATEWAY"] = "gateway";
  SecomEventOrigin2["SYSTEM_ADMIN"] = "system_admin";
  SecomEventOrigin2["API"] = "api";
  return SecomEventOrigin2;
})({});
var SecomTestScenario = /* @__PURE__ */ (function(SecomTestScenario2) {
  SecomTestScenario2["NORMAL"] = "normal";
  SecomTestScenario2["LATE"] = "late";
  SecomTestScenario2["EARLY_LEAVE"] = "early_leave";
  SecomTestScenario2["LATE_AND_EARLY"] = "late_and_early";
  SecomTestScenario2["OVERTIME"] = "overtime";
  SecomTestScenario2["MISSING_CHECK_OUT"] = "missing_check_out";
  SecomTestScenario2["MISSING_CHECK_IN"] = "missing_check_in";
  SecomTestScenario2["DUPLICATE_SCAN"] = "duplicate_scan";
  SecomTestScenario2["ABSENT"] = "absent";
  SecomTestScenario2["OFF_DAY_WORK"] = "off_day_work";
  return SecomTestScenario2;
})({});

// src/enums/sheet-access.enum.ts
var SheetAccessRole = /* @__PURE__ */ (function(SheetAccessRole2) {
  SheetAccessRole2["VIEWER"] = "viewer";
  SheetAccessRole2["EDITOR"] = "editor";
  return SheetAccessRole2;
})({});
var AccessGranteeType = /* @__PURE__ */ (function(AccessGranteeType2) {
  AccessGranteeType2["TEAM"] = "team";
  AccessGranteeType2["EMPLOYEE"] = "employee";
  return AccessGranteeType2;
})({});

// src/enums/sheet-change-set.enum.ts
var SheetChangeSetKind = /* @__PURE__ */ (function(SheetChangeSetKind2) {
  SheetChangeSetKind2["LAYOUT"] = "layout";
  SheetChangeSetKind2["CELLS"] = "cells";
  SheetChangeSetKind2["ROWS"] = "rows";
  SheetChangeSetKind2["IMPORT"] = "import";
  return SheetChangeSetKind2;
})({});
var SheetChangeSetStatus = /* @__PURE__ */ (function(SheetChangeSetStatus2) {
  SheetChangeSetStatus2["PROPOSED"] = "proposed";
  SheetChangeSetStatus2["APPROVED"] = "approved";
  SheetChangeSetStatus2["APPLIED"] = "applied";
  SheetChangeSetStatus2["REJECTED"] = "rejected";
  SheetChangeSetStatus2["REVERTED"] = "reverted";
  return SheetChangeSetStatus2;
})({});
var SheetChangeSetOrigin = /* @__PURE__ */ (function(SheetChangeSetOrigin2) {
  SheetChangeSetOrigin2["AI"] = "ai";
  SheetChangeSetOrigin2["USER"] = "user";
  SheetChangeSetOrigin2["SYSTEM"] = "system";
  return SheetChangeSetOrigin2;
})({});

// src/enums/sheet-view.enum.ts
var SheetViewKind = /* @__PURE__ */ (function(SheetViewKind2) {
  SheetViewKind2["ROW"] = "row";
  SheetViewKind2["TRANSPOSED"] = "transposed";
  SheetViewKind2["MATRIX"] = "matrix";
  return SheetViewKind2;
})({});
var SheetVisibility = /* @__PURE__ */ (function(SheetVisibility2) {
  SheetVisibility2["PRIVATE"] = "private";
  SheetVisibility2["SHARED"] = "shared";
  return SheetVisibility2;
})({});
var SheetCategory = /* @__PURE__ */ (function(SheetCategory2) {
  SheetCategory2["WORKLOG"] = "worklog";
  SheetCategory2["PERFORMANCE"] = "performance";
  SheetCategory2["ROSTER"] = "roster";
  SheetCategory2["STANDARD"] = "standard";
  return SheetCategory2;
})({});
var SheetSetupAction = /* @__PURE__ */ (function(SheetSetupAction2) {
  SheetSetupAction2["COMPLETE"] = "complete";
  SheetSetupAction2["REOPEN"] = "reopen";
  return SheetSetupAction2;
})({});

// src/enums/sign-webhook.enum.ts
var SignWebhookInboxStatus = /* @__PURE__ */ (function(SignWebhookInboxStatus2) {
  SignWebhookInboxStatus2["RECEIVED"] = "received";
  SignWebhookInboxStatus2["PROCESSED"] = "processed";
  SignWebhookInboxStatus2["FAILED"] = "failed";
  return SignWebhookInboxStatus2;
})({});

// src/enums/source-table.enum.ts
var SourceTable = /* @__PURE__ */ (function(SourceTable2) {
  SourceTable2["OvertimeRecord"] = "overtime_record";
  SourceTable2["FixedIncentive"] = "fixed_incentive";
  SourceTable2["LeaveOfAbsenceRecord"] = "leave_of_absence_record";
  SourceTable2["ResignationRecord"] = "resignation_record";
  SourceTable2["ESignRecord"] = "e_sign_record";
  SourceTable2["Attendance"] = "attendance";
  SourceTable2["WardDailyRecord"] = "ward_daily_record";
  SourceTable2["OffsiteWorkRecord"] = "offsite_work_record";
  SourceTable2["RecurringAllowance"] = "recurring_allowance";
  SourceTable2["SalaryGrade"] = "salary_grade";
  SourceTable2["GradePromotionRequest"] = "grade_promotion_request";
  SourceTable2["IncentivePreset"] = "incentive_preset";
  SourceTable2["Employee"] = "employee";
  SourceTable2["AllowanceRecord"] = "allowance_record";
  SourceTable2["DeductionRecord"] = "deduction_record";
  SourceTable2["EmploymentContract"] = "employment_contract";
  SourceTable2["YearEndSettlement"] = "year_end_settlement";
  return SourceTable2;
})({});

// src/enums/system-admin.enum.ts
var SystemAdminUserStatus = /* @__PURE__ */ (function(SystemAdminUserStatus2) {
  SystemAdminUserStatus2["PENDING"] = "PENDING";
  SystemAdminUserStatus2["REJECTED"] = "REJECTED";
  SystemAdminUserStatus2["ACTIVE"] = "ACTIVE";
  SystemAdminUserStatus2["SUSPENDED"] = "SUSPENDED";
  SystemAdminUserStatus2["DEACTIVATED"] = "DEACTIVATED";
  return SystemAdminUserStatus2;
})({});
var SystemAdminAuthMethod = /* @__PURE__ */ (function(SystemAdminAuthMethod2) {
  SystemAdminAuthMethod2["LOCAL"] = "local";
  SystemAdminAuthMethod2["GOOGLE"] = "google";
  return SystemAdminAuthMethod2;
})({});
var SystemAdminAuthChallengeType = /* @__PURE__ */ (function(SystemAdminAuthChallengeType2) {
  SystemAdminAuthChallengeType2["PASSWORD_CHANGE"] = "password_change";
  SystemAdminAuthChallengeType2["TOTP_ENROLLMENT"] = "totp_enrollment";
  SystemAdminAuthChallengeType2["TOTP_VERIFICATION"] = "totp_verification";
  SystemAdminAuthChallengeType2["TOTP_REPLACEMENT"] = "totp_replacement";
  SystemAdminAuthChallengeType2["RECOVERY_CODE"] = "recovery_code";
  SystemAdminAuthChallengeType2["RECENT_REAUTH"] = "recent_reauth";
  return SystemAdminAuthChallengeType2;
})({});
var SystemAdminLoginPolicy = /* @__PURE__ */ (function(SystemAdminLoginPolicy2) {
  SystemAdminLoginPolicy2["LOCAL_ONLY"] = "local_only";
  SystemAdminLoginPolicy2["GOOGLE_ONLY"] = "google_only";
  SystemAdminLoginPolicy2["LOCAL_AND_GOOGLE"] = "local_and_google";
  return SystemAdminLoginPolicy2;
})({});
var SystemAdminRoleStatus = /* @__PURE__ */ (function(SystemAdminRoleStatus2) {
  SystemAdminRoleStatus2["ACTIVE"] = "active";
  SystemAdminRoleStatus2["INACTIVE"] = "inactive";
  return SystemAdminRoleStatus2;
})({});
var SystemAdminMfaFactorType = /* @__PURE__ */ (function(SystemAdminMfaFactorType2) {
  SystemAdminMfaFactorType2["TOTP"] = "totp";
  return SystemAdminMfaFactorType2;
})({});
var SystemAdminMfaFactorStatus = /* @__PURE__ */ (function(SystemAdminMfaFactorStatus2) {
  SystemAdminMfaFactorStatus2["PENDING"] = "pending";
  SystemAdminMfaFactorStatus2["ACTIVE"] = "active";
  SystemAdminMfaFactorStatus2["REVOKED"] = "revoked";
  return SystemAdminMfaFactorStatus2;
})({});
var SystemAdminScopeType = /* @__PURE__ */ (function(SystemAdminScopeType2) {
  SystemAdminScopeType2["GLOBAL"] = "global";
  SystemAdminScopeType2["ENDPOINT"] = "endpoint";
  SystemAdminScopeType2["ORGANIZATION"] = "organization";
  return SystemAdminScopeType2;
})({});
var SystemAdminEndpointRegistrationStatus = /* @__PURE__ */ (function(SystemAdminEndpointRegistrationStatus2) {
  SystemAdminEndpointRegistrationStatus2["PENDING"] = "pending";
  SystemAdminEndpointRegistrationStatus2["REGISTERED"] = "registered";
  SystemAdminEndpointRegistrationStatus2["CONFLICT"] = "conflict";
  SystemAdminEndpointRegistrationStatus2["REJECTED"] = "rejected";
  SystemAdminEndpointRegistrationStatus2["DISABLED"] = "disabled";
  return SystemAdminEndpointRegistrationStatus2;
})({});
var SystemAdminEndpointHealthStatus = /* @__PURE__ */ (function(SystemAdminEndpointHealthStatus2) {
  SystemAdminEndpointHealthStatus2["UNKNOWN"] = "unknown";
  SystemAdminEndpointHealthStatus2["HEALTHY"] = "healthy";
  SystemAdminEndpointHealthStatus2["AUTHENTICATION_FAILED"] = "authentication_failed";
  SystemAdminEndpointHealthStatus2["INCOMPATIBLE"] = "incompatible";
  SystemAdminEndpointHealthStatus2["DEGRADED"] = "degraded";
  SystemAdminEndpointHealthStatus2["UNREACHABLE"] = "unreachable";
  return SystemAdminEndpointHealthStatus2;
})({});
var SystemAdminAppBackendPublicationStatus = /* @__PURE__ */ (function(SystemAdminAppBackendPublicationStatus2) {
  SystemAdminAppBackendPublicationStatus2["UNPUBLISHED"] = "unpublished";
  SystemAdminAppBackendPublicationStatus2["PUBLISHED"] = "published";
  return SystemAdminAppBackendPublicationStatus2;
})({});
var SystemAdminCsReportPrefixSyncStatus = /* @__PURE__ */ (function(SystemAdminCsReportPrefixSyncStatus2) {
  SystemAdminCsReportPrefixSyncStatus2["UNSET"] = "unset";
  SystemAdminCsReportPrefixSyncStatus2["PENDING"] = "pending";
  SystemAdminCsReportPrefixSyncStatus2["SYNCED"] = "synced";
  SystemAdminCsReportPrefixSyncStatus2["FAILED"] = "failed";
  SystemAdminCsReportPrefixSyncStatus2["CONFLICT"] = "conflict";
  return SystemAdminCsReportPrefixSyncStatus2;
})({});
var SystemAdminHospitalCodeSyncStatus = /* @__PURE__ */ (function(SystemAdminHospitalCodeSyncStatus2) {
  SystemAdminHospitalCodeSyncStatus2["UNSET"] = "unset";
  SystemAdminHospitalCodeSyncStatus2["PENDING"] = "pending";
  SystemAdminHospitalCodeSyncStatus2["SYNCED"] = "synced";
  SystemAdminHospitalCodeSyncStatus2["FAILED"] = "failed";
  SystemAdminHospitalCodeSyncStatus2["CONFLICT"] = "conflict";
  return SystemAdminHospitalCodeSyncStatus2;
})({});
var SystemAdminEndpointRegistrationEventType = /* @__PURE__ */ (function(SystemAdminEndpointRegistrationEventType2) {
  SystemAdminEndpointRegistrationEventType2["ANNOUNCED"] = "announced";
  SystemAdminEndpointRegistrationEventType2["HEARTBEAT"] = "heartbeat";
  SystemAdminEndpointRegistrationEventType2["APPROVED"] = "approved";
  SystemAdminEndpointRegistrationEventType2["REJECTED"] = "rejected";
  SystemAdminEndpointRegistrationEventType2["CONFLICT_DETECTED"] = "conflict_detected";
  SystemAdminEndpointRegistrationEventType2["IDENTITY_ROTATED"] = "identity_rotated";
  SystemAdminEndpointRegistrationEventType2["DISABLED"] = "disabled";
  SystemAdminEndpointRegistrationEventType2["INSTANCE_REPLACED"] = "instance_replaced";
  return SystemAdminEndpointRegistrationEventType2;
})({});
var SystemAdminAuditOutcome = /* @__PURE__ */ (function(SystemAdminAuditOutcome2) {
  SystemAdminAuditOutcome2["SUCCESS"] = "success";
  SystemAdminAuditOutcome2["DENIED"] = "denied";
  SystemAdminAuditOutcome2["FAILED"] = "failed";
  SystemAdminAuditOutcome2["PARTIAL"] = "partial";
  return SystemAdminAuditOutcome2;
})({});
var SystemAdminAuditActorKind = /* @__PURE__ */ (function(SystemAdminAuditActorKind2) {
  SystemAdminAuditActorKind2["ADMIN_USER"] = "admin_user";
  SystemAdminAuditActorKind2["SYSTEM"] = "system";
  SystemAdminAuditActorKind2["ENDPOINT"] = "endpoint";
  return SystemAdminAuditActorKind2;
})({});

// src/enums/system-admin-app-version.enum.ts
var SystemAdminAppVersionPlatform = /* @__PURE__ */ (function(SystemAdminAppVersionPlatform2) {
  SystemAdminAppVersionPlatform2["IOS"] = "ios";
  SystemAdminAppVersionPlatform2["ANDROID"] = "android";
  SystemAdminAppVersionPlatform2["WEB"] = "web";
  return SystemAdminAppVersionPlatform2;
})({});
var SystemAdminAppVersionResult = /* @__PURE__ */ (function(SystemAdminAppVersionResult2) {
  SystemAdminAppVersionResult2["UPDATE_REQUIRED"] = "update_required";
  SystemAdminAppVersionResult2["UPDATE_AVAILABLE"] = "update_available";
  SystemAdminAppVersionResult2["UP_TO_DATE"] = "up_to_date";
  return SystemAdminAppVersionResult2;
})({});
var SystemAdminAppVersionPolicyStatus = /* @__PURE__ */ (function(SystemAdminAppVersionPolicyStatus2) {
  SystemAdminAppVersionPolicyStatus2["DRAFT"] = "draft";
  SystemAdminAppVersionPolicyStatus2["PUBLISHED"] = "published";
  SystemAdminAppVersionPolicyStatus2["WITHDRAWN"] = "withdrawn";
  return SystemAdminAppVersionPolicyStatus2;
})({});
var SystemAdminAppVersionHistoryAction = /* @__PURE__ */ (function(SystemAdminAppVersionHistoryAction2) {
  SystemAdminAppVersionHistoryAction2["DRAFT_SAVED"] = "draft_saved";
  SystemAdminAppVersionHistoryAction2["PUBLISHED"] = "published";
  SystemAdminAppVersionHistoryAction2["WITHDRAWN"] = "withdrawn";
  SystemAdminAppVersionHistoryAction2["RESTORED"] = "restored";
  return SystemAdminAppVersionHistoryAction2;
})({});
var SystemAdminBundleSourceStatus = /* @__PURE__ */ (function(SystemAdminBundleSourceStatus2) {
  SystemAdminBundleSourceStatus2["NOT_TESTED"] = "not_tested";
  SystemAdminBundleSourceStatus2["VALID"] = "valid";
  SystemAdminBundleSourceStatus2["INVALID"] = "invalid";
  return SystemAdminBundleSourceStatus2;
})({});
var SystemAdminBundleSyncStatus = /* @__PURE__ */ (function(SystemAdminBundleSyncStatus2) {
  SystemAdminBundleSyncStatus2["NOT_STARTED"] = "not_started";
  SystemAdminBundleSyncStatus2["RUNNING"] = "running";
  SystemAdminBundleSyncStatus2["SUCCEEDED"] = "succeeded";
  SystemAdminBundleSyncStatus2["FAILED"] = "failed";
  return SystemAdminBundleSyncStatus2;
})({});
var SystemAdminBundleCandidateVerificationStatus = /* @__PURE__ */ (function(SystemAdminBundleCandidateVerificationStatus2) {
  SystemAdminBundleCandidateVerificationStatus2["PENDING"] = "pending";
  SystemAdminBundleCandidateVerificationStatus2["VERIFIED"] = "verified";
  SystemAdminBundleCandidateVerificationStatus2["FAILED"] = "failed";
  return SystemAdminBundleCandidateVerificationStatus2;
})({});
var SystemAdminBundlePublicationAction = /* @__PURE__ */ (function(SystemAdminBundlePublicationAction2) {
  SystemAdminBundlePublicationAction2["DRAFT_SAVED"] = "draft_saved";
  SystemAdminBundlePublicationAction2["PUBLISHED"] = "published";
  return SystemAdminBundlePublicationAction2;
})({});

// src/enums/system-admin-service.enum.ts
var SystemAdminServiceAction = /* @__PURE__ */ (function(SystemAdminServiceAction2) {
  SystemAdminServiceAction2["CAPABILITIES_READ"] = "capabilities:read";
  SystemAdminServiceAction2["ORGANIZATIONS_READ"] = "organizations:read";
  SystemAdminServiceAction2["ORGANIZATION_DETAIL_READ"] = "organization:detail:read";
  SystemAdminServiceAction2["ORGANIZATION_STATUS_UPDATE"] = "organization:status:update";
  SystemAdminServiceAction2["ORGANIZATION_UPDATE"] = "organization:update";
  SystemAdminServiceAction2["ORGANIZATION_AI_GUIDANCE_UPDATE"] = "organization:ai-guidance:update";
  SystemAdminServiceAction2["ORGANIZATION_MESSENGER_ENCRYPTION_UPDATE"] = "organization:messenger-encryption:update";
  SystemAdminServiceAction2["ORGANIZATION_DELETE"] = "organization:delete";
  SystemAdminServiceAction2["ORGANIZATION_PROVISION_PREVIEW"] = "organization:provision:preview";
  SystemAdminServiceAction2["ORGANIZATION_SEED_DEFAULTS"] = "organization:provision:seed-defaults";
  SystemAdminServiceAction2["ORGANIZATION_SEED_ITEM_CODES"] = "organization:provision:seed-item-codes";
  SystemAdminServiceAction2["ORGANIZATION_PROVISION_CREATE"] = "organization:provision:create";
  SystemAdminServiceAction2["ORGANIZATION_ADMINS_READ"] = "organization-admins:read";
  SystemAdminServiceAction2["ORGANIZATION_ADMIN_CREATE"] = "organization-admin:create";
  SystemAdminServiceAction2["ORGANIZATION_ADMIN_UPDATE"] = "organization-admin:update";
  SystemAdminServiceAction2["ORGANIZATION_ADMIN_DELETE"] = "organization-admin:delete";
  SystemAdminServiceAction2["ORGANIZATION_ROLES_READ"] = "organization-roles:read";
  SystemAdminServiceAction2["ORGANIZATION_PERMISSIONS_READ"] = "organization-permissions:read";
  SystemAdminServiceAction2["ORGANIZATION_ROLE_CREATE"] = "organization-role:create";
  SystemAdminServiceAction2["ORGANIZATION_ROLE_UPDATE"] = "organization-role:update";
  SystemAdminServiceAction2["ORGANIZATION_ROLE_DELETE"] = "organization-role:delete";
  SystemAdminServiceAction2["ORGANIZATION_ATTENDANCE_READ"] = "organization-attendance:read";
  SystemAdminServiceAction2["ORGANIZATION_EMPLOYEES_READ"] = "organization-employees:read";
  SystemAdminServiceAction2["SECOM_EVENTS_READ"] = "secom-events:read";
  SystemAdminServiceAction2["SECOM_EVENT_CREATE"] = "secom-event:create";
  SystemAdminServiceAction2["SECOM_EVENT_UPDATE"] = "secom-event:update";
  SystemAdminServiceAction2["SECOM_EVENT_DELETE"] = "secom-event:delete";
  SystemAdminServiceAction2["SECOM_EVENT_TEST_PLAN_READ"] = "secom-event-test-plan:read";
  SystemAdminServiceAction2["SECOM_EVENT_TEST_GENERATE"] = "secom-event-test:generate";
  SystemAdminServiceAction2["ATTENDANCE_RECALCULATE"] = "attendance:recalculate";
  SystemAdminServiceAction2["AI_SUMMARY_READ"] = "ai-summary:read";
  SystemAdminServiceAction2["AI_CONVERSATIONS_READ"] = "ai-conversations:read";
  SystemAdminServiceAction2["AI_CONVERSATION_DETAIL_READ"] = "ai-conversation-detail:read";
  SystemAdminServiceAction2["AI_ERRORS_READ"] = "ai-errors:read";
  SystemAdminServiceAction2["NATIONAL_HOLIDAY_YEARS_READ"] = "national-holiday-years:read";
  SystemAdminServiceAction2["NATIONAL_HOLIDAYS_READ"] = "national-holidays:read";
  SystemAdminServiceAction2["NATIONAL_HOLIDAYS_SYNC"] = "national-holidays:sync";
  SystemAdminServiceAction2["INTEGRATION_CREDENTIALS_READ"] = "integration-credentials:read";
  SystemAdminServiceAction2["INTEGRATION_CREDENTIAL_CREATE"] = "integration-credential:create";
  SystemAdminServiceAction2["INTEGRATION_CREDENTIAL_UPDATE"] = "integration-credential:update";
  SystemAdminServiceAction2["INTEGRATION_WEBHOOK_SECRET_GENERATE"] = "integration-webhook-secret:generate";
  SystemAdminServiceAction2["INTEGRATION_WEBHOOK_SECRET_REVOKE"] = "integration-webhook-secret:revoke";
  SystemAdminServiceAction2["INTEGRATION_CREDENTIAL_DELETE"] = "integration-credential:delete";
  SystemAdminServiceAction2["SECOM_SYNC_READ"] = "secom-sync:read";
  SystemAdminServiceAction2["SECOM_SYNC_CREATE"] = "secom-sync:create";
  SystemAdminServiceAction2["SECOM_SYNC_TOGGLE"] = "secom-sync:toggle";
  SystemAdminServiceAction2["SECOM_SYNC_RESET"] = "secom-sync:reset";
  SystemAdminServiceAction2["SECOM_SYNC_DELETE"] = "secom-sync:delete";
  SystemAdminServiceAction2["SYSTEM_TEMPLATES_READ"] = "system-templates:read";
  SystemAdminServiceAction2["SYSTEM_TEMPLATE_UPDATE"] = "system-template:update";
  SystemAdminServiceAction2["SHEET_TEMPLATE_DETAIL_READ"] = "sheet-template-detail:read";
  SystemAdminServiceAction2["SHEET_TEMPLATE_CREATE"] = "sheet-template:create";
  SystemAdminServiceAction2["SHEET_TEMPLATE_DELETE"] = "sheet-template:delete";
  SystemAdminServiceAction2["ORGANIZATION_SHEETS_READ"] = "organization-sheets:read";
  SystemAdminServiceAction2["SHEET_TEMPLATE_CREATE_FROM_SHEET"] = "sheet-template:create-from-sheet";
  SystemAdminServiceAction2["CS_REPORTS_READ"] = "cs-reports:read";
  SystemAdminServiceAction2["CS_REPORT_DETAIL_READ"] = "cs-report-detail:read";
  SystemAdminServiceAction2["CS_REPORT_LOG_READ"] = "cs-report-log:read";
  SystemAdminServiceAction2["CS_REPORT_TRANSITION"] = "cs-report:transition";
  SystemAdminServiceAction2["CS_REPORT_COMMENT"] = "cs-report:comment";
  SystemAdminServiceAction2["CS_REPORT_PREFIX_SYNC"] = "cs-report-prefix:sync";
  SystemAdminServiceAction2["HOSPITAL_CODE_SYNC"] = "hospital-code:sync";
  SystemAdminServiceAction2["PLATFORM_ACCOUNTS_READ"] = "platform-accounts:read";
  SystemAdminServiceAction2["CHAT_RECOVERY_REQUESTS_READ"] = "chat-recovery-requests:read";
  SystemAdminServiceAction2["CHAT_RECOVERY_REQUEST_DETAIL_READ"] = "chat-recovery-request-detail:read";
  SystemAdminServiceAction2["CHAT_RECOVERY_OPERATOR_APPROVE"] = "chat-recovery:operator-approve";
  SystemAdminServiceAction2["CHAT_RECOVERY_ENVELOPES_READ"] = "chat-recovery-envelopes:read";
  SystemAdminServiceAction2["CHAT_RECOVERY_RELEASE"] = "chat-recovery:release";
  SystemAdminServiceAction2["CHAT_RECOVERY_DOCUMENT_READ"] = "chat-recovery-document:read";
  SystemAdminServiceAction2["PLATFORM_ACCOUNT_CREATE"] = "platform-account:create";
  SystemAdminServiceAction2["PLATFORM_ACCOUNT_ROLE_UPDATE"] = "platform-account-role:update";
  SystemAdminServiceAction2["ACCOUNT_ORGANIZATIONS_READ"] = "account-organizations:read";
  SystemAdminServiceAction2["ORGANIZATION_LINKABLE_EMPLOYEES_READ"] = "organization-linkable-employees:read";
  SystemAdminServiceAction2["ACCOUNT_EMPLOYEE_LINK"] = "account-employee:link";
  SystemAdminServiceAction2["ACCOUNT_EMPLOYEE_CREATE"] = "account-employee:create";
  return SystemAdminServiceAction2;
})({});
var SystemAdminServiceScopeKind = /* @__PURE__ */ (function(SystemAdminServiceScopeKind2) {
  SystemAdminServiceScopeKind2["ALL"] = "all";
  SystemAdminServiceScopeKind2["ORGANIZATIONS"] = "organizations";
  return SystemAdminServiceScopeKind2;
})({});

// src/enums/team.enum.ts
var TeamManagerStatusFilter = /* @__PURE__ */ (function(TeamManagerStatusFilter2) {
  TeamManagerStatusFilter2["PENDING"] = "pending";
  TeamManagerStatusFilter2["APPROVED"] = "approved";
  TeamManagerStatusFilter2["REJECTED"] = "rejected";
  TeamManagerStatusFilter2["ALL"] = "all";
  return TeamManagerStatusFilter2;
})({});
var TeamStatus = /* @__PURE__ */ (function(TeamStatus2) {
  TeamStatus2["ACTIVE"] = "ACTIVE";
  TeamStatus2["INACTIVE"] = "INACTIVE";
  TeamStatus2["FORMING"] = "FORMING";
  TeamStatus2["DISBANDED"] = "DISBANDED";
  return TeamStatus2;
})({});
var TeamType = /* @__PURE__ */ (function(TeamType2) {
  TeamType2["PERMANENT"] = "PERMANENT";
  TeamType2["PROJECT"] = "PROJECT";
  TeamType2["TASK_FORCE"] = "TASK_FORCE";
  TeamType2["COMMITTEE"] = "COMMITTEE";
  TeamType2["CROSS_FUNCTIONAL"] = "CROSS_FUNCTIONAL";
  TeamType2["VIRTUAL"] = "VIRTUAL";
  TeamType2["SELF_MANAGED"] = "SELF_MANAGED";
  TeamType2["OTHER"] = "OTHER";
  return TeamType2;
})({});
var TeamMemberRole = /* @__PURE__ */ (function(TeamMemberRole2) {
  TeamMemberRole2["LEADER"] = "LEADER";
  TeamMemberRole2["MEMBER"] = "MEMBER";
  TeamMemberRole2["COORDINATOR"] = "COORDINATOR";
  TeamMemberRole2["SPECIALIST"] = "SPECIALIST";
  TeamMemberRole2["ADVISOR"] = "ADVISOR";
  TeamMemberRole2["OBSERVER"] = "OBSERVER";
  return TeamMemberRole2;
})({});
var TeamMemberStatus = /* @__PURE__ */ (function(TeamMemberStatus2) {
  TeamMemberStatus2["ACTIVE"] = "ACTIVE";
  TeamMemberStatus2["INACTIVE"] = "INACTIVE";
  TeamMemberStatus2["PENDING"] = "PENDING";
  TeamMemberStatus2["LEFT"] = "LEFT";
  return TeamMemberStatus2;
})({});
var TeamSortBy = /* @__PURE__ */ (function(TeamSortBy2) {
  TeamSortBy2["NAME"] = "name";
  TeamSortBy2["CODE"] = "code";
  TeamSortBy2["CREATED_AT"] = "createdAt";
  return TeamSortBy2;
})({});
var TeamMemberOperation = /* @__PURE__ */ (function(TeamMemberOperation2) {
  TeamMemberOperation2["ADD"] = "ADD";
  TeamMemberOperation2["UPDATE"] = "UPDATE";
  TeamMemberOperation2["REMOVE"] = "REMOVE";
  return TeamMemberOperation2;
})({});

// src/enums/work-time-closing.enum.ts
var WorkTimeConfirmStatus = /* @__PURE__ */ (function(WorkTimeConfirmStatus2) {
  WorkTimeConfirmStatus2["UNCONFIRMED"] = "unconfirmed";
  WorkTimeConfirmStatus2["CONFIRMED"] = "confirmed";
  return WorkTimeConfirmStatus2;
})({});

// src/enums/workflow-message-outbox.enum.ts
var WorkflowMessageOutboxStatus = /* @__PURE__ */ (function(WorkflowMessageOutboxStatus2) {
  WorkflowMessageOutboxStatus2["PENDING"] = "pending";
  WorkflowMessageOutboxStatus2["PROCESSING"] = "processing";
  WorkflowMessageOutboxStatus2["DELIVERED"] = "delivered";
  WorkflowMessageOutboxStatus2["FAILED"] = "failed";
  return WorkflowMessageOutboxStatus2;
})({});
export {
  AccessGranteeType,
  AccountStatus,
  AccrualType,
  AiChatPurpose,
  AiDocumentOriginKind,
  AiDocumentSpanKind,
  AiErrorCode,
  AiFeedbackRating,
  AiGuidanceAnswerStatus,
  AiGuidanceAvailability,
  AiGuidanceQuestionKind,
  AiGuideProvider,
  AiGuideSearchStatus,
  AiKeySource,
  AiMessageRole,
  AiMessageStatus,
  AiModule,
  AllowanceStatus,
  AllowanceSubCategory,
  AllowanceType,
  AmendmentType,
  AnnualLeavePromotionAttemptStatus,
  AnnualLeavePromotionBatchItemStatus,
  AnnualLeavePromotionBatchStatus,
  AnnualLeavePromotionBusinessStatus,
  AnnualLeavePromotionMessagePurpose,
  AnnualLeavePromotionProcessingStatus,
  AnnualLeavePromotionSelectionMode,
  AppGuideChannel,
  AppGuideSendStatus,
  AppGuideTargetMode,
  AppOnboardingChecklistStep,
  AppOnboardingStage,
  AppTutorialStep,
  ApprovalChangeEvent,
  ApprovalChangeTarget,
  ApprovalRequestType,
  ApprovalStepStatus,
  AssignmentType,
  AttendanceActionType,
  AttendanceCorrectionKind,
  AttendanceCorrectionStatus,
  AttendanceDisplayStatus,
  AttendanceMethod,
  AttendanceRateRoundingMode,
  AttendanceStatus,
  AttendanceType,
  AuditActorKind,
  AuthMethod,
  CellMemoStatus,
  CertificationType,
  ChatDeviceLinkStatus,
  ChatRecoveryActorKind,
  ChatRecoveryAuditStep,
  ChatRecoveryReasonKind,
  ChatRecoveryStatus,
  CompletionStatus,
  ContractSortBy,
  ContractStatus,
  ContractType,
  ConversationKeyEpochReason,
  ConversationMemberRole,
  ConversationMembershipStatus,
  ConversationType,
  CsReportApp,
  CsReportAttachmentKind,
  CsReportCommentAuthorKind,
  CsReportCommentVisibility,
  CsReportPriority,
  CsReportSessionKind,
  CsReportStatus,
  CsReportStatusActorKind,
  CsReportTriageState,
  CsReportType,
  DayOfWeek,
  DeductionExclusionReason,
  DeductionSettlementState,
  DeductionStatus,
  DeductionSubCategory,
  DeliveryChannel,
  DeliveryStatus,
  DeviceCredentialKind,
  DevicePlatform,
  DocumentCategory,
  DocumentReviewAction,
  DocumentStatus,
  DriveAccessMode,
  DriveAccessRole,
  DriveGranteeType,
  DriveTargetType,
  ESignFilterStatus,
  ESignRemoteStatusCode,
  ESignStatus,
  EmployeeHomeSection,
  EmployeeStatus,
  ExecutionStatus,
  ExternalIntegrationProvisioningStatus,
  FiscalNewHireMode,
  FixedIncentiveStatus,
  GrantKind,
  GrantOrigin,
  HalfDayPeriod,
  HolidayWorkMode,
  HospitalSize,
  HrActionKind,
  HrAppointmentAction,
  IncentiveCategory,
  InquiryPain,
  IntegrationCredentialStatus,
  IntegrationHealthStatus,
  IntegrationProvider,
  IntegrationWebhookSecretStatus,
  JobCategory,
  LeaveAccrualBasis,
  LeaveDeductionMode,
  LeaveImportBatchStatus,
  LeaveImportFormat,
  LeaveImportTerminatedPolicy,
  LeaveLedgerEntryType,
  LeaveOfAbsenceStatus,
  LeaveStatus,
  LeaveType,
  MessageType,
  MessengerPushFormat,
  NoticeCategory,
  NoticePriority,
  NotificationAction,
  NotificationMuteType,
  NotificationPushCategory,
  NotificationType,
  NurseWardReservationStatus,
  NurseWorkType,
  OffsiteWorkStatus,
  OrganizationSize,
  OrganizationSortBy,
  OrganizationStatus,
  OrganizationType,
  OvertimeCategory,
  OvertimeStatus,
  PayFrequency,
  PaymentMethod,
  PayrollSourceType,
  PayrollStatus,
  PermissionActionType,
  PermissionAuditAction,
  PermissionAuditEntityType,
  PermissionScope,
  PermissionSortBy,
  PermissionType,
  PlatformRole,
  PreferenceStatus,
  ProbationStatus,
  ProcessPaymentMethod,
  PromotionStatus,
  PromotionType,
  RecurrencePattern,
  ResetMethod,
  ResignationStatus,
  ResourceType,
  RoleAssignmentOperation,
  RoleStatus,
  RoleType,
  RotationPeriod,
  SCHEDULED_ACTION_RECORD_KINDS,
  SalaryGradeCategory,
  SalaryGradeStatus,
  SalaryIncreaseType,
  ScheduleStatus,
  ScheduledActionGroupPolicy,
  ScheduledActionKind,
  ScheduledActionOrigin,
  ScheduledActionStatus,
  ScheduledChangeApplyPolicy,
  ScreenCaptureEventKind,
  ScreenCaptureScreen,
  SecomEventOrigin,
  SecomEventStatus,
  SecomEventType,
  SecomTestScenario,
  SettlementStatus,
  SheetAccessRole,
  SheetCategory,
  SheetChangeSetKind,
  SheetChangeSetOrigin,
  SheetChangeSetStatus,
  SheetContractBasis,
  SheetSetupAction,
  SheetViewKind,
  SheetVisibility,
  ShiftAssignmentSource,
  ShiftAssignmentStatus,
  ShiftClassification,
  ShiftResolutionSource,
  ShiftSortBy,
  ShiftStatus,
  ShiftSwapStatus,
  ShiftType,
  SignWebhookInboxStatus,
  SortOrder,
  SourceModule,
  SourceTable,
  SubsidyStatus,
  SystemAdminAppBackendPublicationStatus,
  SystemAdminAppVersionHistoryAction,
  SystemAdminAppVersionPlatform,
  SystemAdminAppVersionPolicyStatus,
  SystemAdminAppVersionResult,
  SystemAdminAuditActorKind,
  SystemAdminAuditOutcome,
  SystemAdminAuthChallengeType,
  SystemAdminAuthMethod,
  SystemAdminBundleCandidateVerificationStatus,
  SystemAdminBundlePublicationAction,
  SystemAdminBundleSourceStatus,
  SystemAdminBundleSyncStatus,
  SystemAdminCsReportPrefixSyncStatus,
  SystemAdminEndpointHealthStatus,
  SystemAdminEndpointRegistrationEventType,
  SystemAdminEndpointRegistrationStatus,
  SystemAdminHospitalCodeSyncStatus,
  SystemAdminLoginPolicy,
  SystemAdminMfaFactorStatus,
  SystemAdminMfaFactorType,
  SystemAdminRoleStatus,
  SystemAdminScopeType,
  SystemAdminServiceAction,
  SystemAdminServiceScopeKind,
  SystemAdminUserStatus,
  TaskCategory,
  TaskFrequency,
  TaxExemptType,
  TeamManagerStatusFilter,
  TeamMemberOperation,
  TeamMemberRole,
  TeamMemberStatus,
  TeamPermissionScope,
  TeamSortBy,
  TeamStatus,
  TeamType,
  TerminationReason,
  TokenStatus,
  TokenType,
  TrainingCategory,
  TrainingFrequency,
  TreatmentSessionRequestStatus,
  TwoFactorMethod,
  VerificationType,
  WageType,
  WardCareType,
  WardPatientCountSource,
  WorkTimeConfirmStatus,
  WorkTypeChangeStatus,
  WorkflowMessageOutboxStatus,
  WorkflowMessagePublicationState,
  isScheduledActionRecordKind
};
//# sourceMappingURL=enums.mjs.map